import React, { ReactElement, Component, useState, useEffect, useContext, Fragment, useCallback, useMemo, Context } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
// import '@ant-design/compatible/assets/index.css';
import { Row, Col, Input, Button, Table, Dropdown, Menu, Progress, Typography, Tooltip } from "antd";
import { withRouter, Link } from "react-router-dom";
import { ColumnProps } from "antd/es/table";
import "./table-list.less";
import { item, ItemsContext } from "../../contexts/items";
import { change_unit } from "../../pages/global/global";
import { CardSelectableContext } from "../../contexts/card-selectable";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { WorkloadSelectedContext } from "../../contexts/workload-selected";
import { IngressSelectedContext } from "../../contexts/ingress-selected";
import { ingress_type_item } from "../../contexts/ingress";
import { workspaces_type_item, WorkspaceContext } from "../../contexts/workspaces";
import { quota_type, QuotaContext } from "../../contexts/quota-management";
import { namespaces_type_item, NamespaceContext } from "../../contexts/namespaces";
import { TableDescContext } from "../../contexts/table-desc";
import { key_to_title, get_time } from "../../shared-functions";
import { SideFlyInContext } from "../../contexts/side-menu-fly-in";
import { ItemSelectedContext } from "../../contexts/item-selected";
import BreadCrumbs from "../breadcrumb/breadcrumb";
import DropdownMenu from "../dropdown-menu/dropdown-menu";
import { PhysicalResourceQuotaUsage } from "../../pages/workspace-overview/workspace-overview";
import { permissions, permission_in_roles_array } from "../../permissions";
import { linkon, linkoff } from "../../img";
import { prevent } from "../../pages/applications/applications";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  RightOutlined,
  // EditOutlined,
  DeleteFilled,
  MoreOutlined,
  SearchOutlined,
  PlusOutlined,
  DownOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { TypeNameContext } from "../../contexts/type_name";
import TableListModal from "../table-list-modal/table-list-modal";
import { UserInfoContext, IUserInfoType } from "../../contexts/user-info";
import { UnitContext } from "../../contexts/unit";
// import { get_db, set_db } from "../../worker/db-func";
import { get_db } from "../../worker/db-func";
import { formatDate } from "../../pages/user-management/user-util";
import { SortFirstContext } from "../../contexts/sort-first";
import { ThemeContext } from "../../components/../contexts/theme";
import { TableListModalTypeContext, table_list_modal_type } from "../../contexts/table_list_modal";
// import { http_request, destroy_worker } from "../../worker/http-func";
// import { ReplicaNumberContext, replica_number_type } from "../../contexts/replica-number";
// import { DatacenternameContext } from "../../components/../contexts/datacenter-name";
import { WorkloadInfoPod } from "../../pages/workload-list/workload-list";
import { PodsContext, pods_type_item } from "../../contexts/pods";
import { warning_circle, active_circle, offline_circle, fail_circle } from "../../img";
import { useDeepCompareMemo } from 'use-deep-compare';
import {format_time} from '../../pages/applications/common-file/service';

const { Text } = Typography;

interface display {
  cluster: boolean;
  workspace: boolean;
  namespace: boolean;
  has_all: boolean;
}

// export interface table_list_modal_type {
//   modal_title: string | JSX.Element[];
//   modal_message: JSX.Element | undefined;
//   modal_ok_button: boolean;
//   action: number; //新增0 修改1 刪除2
//   visible: boolean;
//   is_config: boolean;
//   is_logs: boolean;
//   is_web_kubectl: boolean;
//   quota_selected: string | undefined;
//   is_details: boolean;
//   is_yaml: boolean;
// }

export interface row {
  key: string;
  name: string;
  status: string;
  updatetime: string;
  cpu: { usedCPU: string; limitCPU?: string };
  memory: { usedMemory: string; limitMemory?: string };
  rootfs: { usedRootfs?: string; limitsRoofs?: string };
  pod: number;
  pvc: number;
  quotaName: string;
  type: string;
}

export interface loading_type {
  logs?: boolean;
  config?: boolean;
  yaml_ingress?: boolean;
  container?: boolean;
}

export interface user_subscription_all {
  id: string;
  name: string;
  createTime: number;
  modifyTime: number;
  company: string;
  members: number;
}

interface sorter_type {
  columnKey: string;
  order: string;
}

export const select = (
    name_selected: string,
    set_func: React.Dispatch<React.SetStateAction<item | undefined>>,
    is_workspaces: boolean,
    items?: (workspaces_type_item | namespaces_type_item)[]
  ) => {
    if (name_selected !== "") {
      const item_found: workspaces_type_item | namespaces_type_item | undefined = items?.find(
        ({ metadata }: workspaces_type_item | namespaces_type_item) =>
          (is_workspaces ? (metadata as workspaces_type_item["metadata"])?.labels?.name : (metadata as namespaces_type_item["metadata"])?.name) ===
          name_selected
      );
      if (item_found) {
        set_func(item_found.metadata);
        sessionStorage.setItem(`${is_workspaces ? "work" : "name"}space`, item_found.metadata.name);
      }
    } else {
      set_func(undefined);
      sessionStorage.removeItem(`${is_workspaces ? "work" : "name"}space`);
    }
  },
  select_display = (path: string): display => {
    let display: display = {} as display;
    switch (path) {
      case 'storage-info/pv':
      case 'storage-info/storage':
      case "cluster-info/workspaces":
        display.cluster = true;
        break;
      case "workspace-info/overview":
      case "workspace-info/namespaces":
        display.cluster = true;
        display.workspace = true;
        break;
      case 'storage-info/pvc':
      case "namespace-info/overview":
      case "namespace-info/workloads":
      case "ingress-info/ingress":
      case "application/workload":
      case "restart-alarm":
        display.cluster = true;
        display.workspace = true;
        display.namespace = true;
        break;
      case "nodes":
        display.cluster = true;
        break;
      case "quotas/workspace-quotas":
        display.cluster = true;
        break;
      case "quotas/namespace-quotas":
        display.cluster = true;
        display.workspace = true;
        break;
    }

    if (path.includes("monitor")) {
      display.cluster = true;
      display.workspace = true;
      display.namespace = true;
      display.has_all = true;
    }
    return display;
  };


const persistent_page: string[] = ['pv', 'pvc', 'storage'];

export const TableListModalContext: Context<[table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>]> = React.createContext<
  [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>]
>([{ visible: false } as table_list_modal_type, (_value: any) => { }]);
const TableList: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [table_list_modal, set_table_list_modal]: [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>] = useContext(
    TableListModalTypeContext
  ),
    // [table_list_modal, set_table_list_modal]: [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>] = useState({
    //     visible: false,
    //   } as table_list_modal_type),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    [items, set_items]: [item[], React.Dispatch<React.SetStateAction<item[]>>] = useContext(ItemsContext),
    [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>] = useContext(
      WorkspaceContext
    ),
    namespaces: namespaces_type_item[] | undefined = useContext(NamespaceContext)[0],
    quotas: quota_type["items"] = useContext(QuotaContext)[0],
    [cluster_selected, set_cluster_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(ClusterSelectedContext),
    [workspace_selected, set_workspace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(
      WorkSpaceSelectedContext
    ),
    [namespace_selected, set_namespace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(
      NameSpaceSelectedContext
    ),
    set_workload_selected: React.Dispatch<React.SetStateAction<item>> = useContext(WorkloadSelectedContext)[1],
    set_ingress_selected: React.Dispatch<React.SetStateAction<ingress_type_item>> = useContext(IngressSelectedContext)[1],
    [item_selected, set_item_selected]: [item, React.Dispatch<React.SetStateAction<item>>] = useContext(ItemSelectedContext),
    [side_fly_in, set_side_fly_in]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(SideFlyInContext),
    // [application_workload, set_application_workload]: [application_workload_type_item[] | undefined, React.Dispatch<React.SetStateAction<application_workload_type_item[] | undefined>>] = useContext(ApplicationWorkloadContext),
    // [replica_number, set_replica_number]: [replica_number_type | undefined, React.Dispatch<React.SetStateAction<replica_number_type | undefined>>] = useContext(ReplicaNumberContext),
    // datacenter_name: string | undefined = useContext(DatacenternameContext)[0],

    card_selectable: boolean = useContext(CardSelectableContext)[0],
    unit_provide: string = useContext(UnitContext)[0],
    table_desc: string[] = useContext(TableDescContext)[0],
    type_name: string | undefined = useContext(TypeNameContext)[0],
    sort_first: string = useContext(SortFirstContext)[0],
    theme: string = useContext(ThemeContext)[0],
    set_pods: React.Dispatch<React.SetStateAction<pods_type_item[] | undefined>> = useContext(PodsContext)[1],
    [search_value, set_search_value]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [quota_is_assigned, set_quota_is_assigned]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    [menu, set_menu]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [workspace_column, set_workspace_column]: [ColumnProps<row>[], React.Dispatch<React.SetStateAction<ColumnProps<row>[]>>] = useState<ColumnProps<row>[]>([]),
    [persistent_column, set_persistent_column]: [ColumnProps<row>[], React.Dispatch<React.SetStateAction<ColumnProps<row>[]>>] = useState<ColumnProps<row>[]>([]),
    [expanded_keys, set_expanded_keys]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState<string[]>([]),
    [table, set_table]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [table_desc_el_0, set_table_desc_el_0]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    // [table_desc_el_1, set_table_desc_el_1]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [summary, set_summary]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [page_key, set_page_key]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
    [page_number, set_page_number]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(1),
    [fly_icon, set_fly_icon]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
    [default_sorter, set_default_sorter]: [sorter_type, React.Dispatch<React.SetStateAction<sorter_type>>] = useState<sorter_type>({} as sorter_type),
    [np_add, set_np_add]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    [wk_has_np, set_wk_has_np]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    // [show_scale_warning, set_show_scale_warning]: [boolean[], React.Dispatch<React.SetStateAction<boolean[]>>] = useState<boolean[]>([]),
    path = props.history.location.pathname.substring(1),
    position: number = useMemo(() => path.lastIndexOf("/") + 1, [path]),
    list_type: string = useMemo(() => path.substr(position, path.length - position).replace(/-/gi, ""), [path, position]),
    { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),
    permission = useMemo(() => {
      return (user_info.role && user_info.role !== "" && (permissions[list_type] as permission_in_roles_array)[user_info.role]) || new Int32Array();
    }, [list_type, user_info.role]),
    bind_quota = useCallback(
      (quota_name: string, event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
        prevent(event as React.MouseEvent<HTMLDivElement | HTMLAnchorElement, MouseEvent>);
        set_table_list_modal((currentState) => ({
          ...currentState,
          visible: true,
        }));
        const is_workspace = path.includes("workspace"),
          item_selected_new: item | undefined = is_workspace ? workspace_selected : namespace_selected;

        if (item_selected_new?.quotaName) {
          if (quota_name !== item_selected_new.quotaName) {
            set_table_list_modal((currentState) => ({
              ...currentState,
              modal_title: formatMessage({ id: "assign_quota" }),
              modal_message: (
                <FormattedMessage
                  id="assign_quota_msg"
                  values={{
                    key: is_workspace ? formatMessage({ id: "workspace" }) : formatMessage({ id: "namespace" }),
                    keyName: <b>{(is_workspace ? item_selected_new?.labels : item_selected_new)?.name}</b>,
                    quotaInit: <b>{item_selected_new.quotaName}</b>,
                    quotaNew: <b>{quota_name}</b>,
                  }}
                />
              ),
              modal_ok_button: false,
            }));
            set_table_list_modal((currentState) => ({
              ...currentState,
              visible: true,
              quota_selected: quota_name,
            }));
          } else {
            set_table_list_modal((currentState) => ({
              ...currentState,
              modal_title: formatMessage({ id: "unassign_quota" }),
              is_unassign_quota: true,
            }));
            if (!is_workspace) {
              set_table_list_modal((currentState) => ({
                ...currentState,
                modal_message: (
                  <FormattedMessage
                    id="are_you_sure_to_unassign the quota_quotaName_in_namesapce_namespaceName"
                    values={{
                      quotaName: <b>{quota_name}</b>,
                      namespaceName: <b>{item_selected_new.name}</b>,
                    }}
                  />
                ),
                modal_ok_button: false,
              }));
              set_table_list_modal((currentState) => ({
                ...currentState,
                quota_selected: undefined,
              }));
            } else {
              set_table_list_modal((currentState) => ({
                ...currentState,
                modal_message: (
                  <FormattedMessage
                    id="donot_unassign_auota"
                    values={{
                      key: !is_workspace ? `${formatMessage({ id: "namespace_lower" })}${formatMessage({ id: "quota" })}` : `${formatMessage({ id: "workspace_lower" })}${formatMessage({ id: "quota" })}`
                    }}
                  />
                ),
                modal_ok_button: true,
                quota_selected: quota_name,
              }));
            }
          }
        } else {
          set_table_list_modal((currentState) => ({
            ...currentState,
            modal_title: "Assign Quota",
            modal_message: (
              <span>
                Are you sure to assign the quota <b>{quota_name}</b> to {is_workspace ? "workspace" : "namespace"}{" "}
                <b>{is_workspace ? workspace_selected?.name : namespace_selected?.name}</b> ?
              </span>
            ),
          }));
          set_table_list_modal((currentState) => ({
            ...currentState,
            quota_selected: quota_name,
          }));
        }
      },
      [namespace_selected, path, workspace_selected, set_table_list_modal, formatMessage]
    ),
    space_delete = useCallback(() => {
      set_table_list_modal((currentState) => ({
        ...currentState,
        action: 2,
        visible: true,
        modal_title: `${formatMessage({ id: "delete" })} ${
          path.includes("workspaces")
            ? workspaces?.find((workspace) => workspace?.metadata?.name === item_selected.name)?.metadata?.labels?.name
            : item_selected.name
          }`,
      }));
      if (quota_is_assigned) {
        set_table_list_modal((currentState) => ({
          ...currentState,
          modal_message: (
            <p>
              <FormattedMessage id="delete_quota_desc" />
            </p>
          ) /*这个quota现在正在被使用，无法删除*/,
          modal_ok_button: true,
        }));
      } else {
        set_table_list_modal((currentState) => ({
          ...currentState,
          modal_message: (
            <p>
              <FormattedMessage id="delete_desc" />
            </p>
          ) /*你确定要删除吗?*/,
          modal_ok_button: false,
        }));
      }
    }, [item_selected.name, path, quota_is_assigned, workspaces, set_table_list_modal, formatMessage]),

    // 切换页码
    changePage = useCallback(
      (pageNumber: number) => {
        set_page_number(pageNumber);
      },
      [set_page_number]
    ),
    // 單選
    select: (item: item, click: boolean) => void = useCallback(
      (item: item, click: boolean): void => {
        if (card_selectable) {
          if (click) props.history.push(`/${item.key}-info/overview`);
          switch (item.key) {
            case "cluster":
              set_cluster_selected(item);
              item.name && sessionStorage.setItem("cluster", item.name);
              break;
            case "workspace":
              set_workspace_selected(item);
              item.name && sessionStorage.setItem("workspace", item.name);
              break;

            case "namespace":
              set_namespace_selected(item);
              item.name && sessionStorage.setItem("namespace", item.name);
              break;

            case "workload":
              set_workload_selected(item);
              item.name && sessionStorage.setItem("workload", item.name);
              break;
          }
        } else {
          if (path.includes("quota") || path.includes("scale")) {
            item.name && sessionStorage.setItem("quota", item.name);
          } else if (path.includes("workloads")) {
            set_pods(undefined);
            expanded_keys[0] === "" || item.name !== sessionStorage.getItem("workload") ? set_workload_selected(item) : set_workload_selected({});
            item.name && sessionStorage.setItem("workload", item.name);
          }
        }
      },
      [card_selectable, path, props, set_cluster_selected, set_namespace_selected, set_workload_selected, set_workspace_selected, set_pods, expanded_keys]
    ),
    // 如有麵包屑，須加上offset（之後須改成 useEffect + useState）
    has_offset: boolean = useMemo(
      () => list_type !== "clusters" && list_type !== "nodes" && list_type !== "scale" && list_type !== "workload",
      [list_type]
    ),
    // 計算欄寬（之後須改成 useEffect + useState）
    col_width: number = useMemo(
      () =>
        user_info
          ? 24 - 4 -
          (select_display(path).cluster ? 4 : 0) -
          (select_display(path).workspace ? 4 : 0) -
          (select_display(path).namespace ? 4 : 0) -
          ((permission[0] &&
            !path.includes("scale") &&
            !path.includes("nodes") && list_type !== 'storage' && list_type !== 'pv' &&
            !(path.includes("cluster-info/workspaces") && type_name === "shared" && !user_info.is_globaladmin)) ||
            (path.includes("clusters") && user_info.is_globaladmin)
            ? 1
            : 0)
          : 0,
      [path, user_info, permission, type_name, list_type]
    );

  // workloads scale input change事件
  // input_scale_number = useCallback((value: number | string, record: any, num: number) => {
  //   (async () => {
  //     const scale_reg = /^([0-9]|10)$/;
  //     const init_data: boolean[] = [];
  //     items.map(() => init_data.push(false))
  //     if (scale_reg.test(value?.toString())) {
  //       init_data[num] = false;
  //       set_show_scale_warning(init_data);
  //       const cluster_selected_name: string | undefined = cluster_selected?.name,
  //         namespace_selected_name: string | undefined = namespace_selected?.name;
  //       if (cluster_selected_name && namespace_selected_name && datacenter_name && value >= 0 && value <= 10) {
  //         const change_replica: any = await http_request('change_replica', undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/${record.type?.toLocaleLowerCase() === 'deployment' ? 'deployment' : record.type?.toLocaleLowerCase() === 'statefulset' && 'statefulset'}/${record.name}/replica/${value}`, 2, user_info.role, undefined, datacenter_name, cluster_selected_name);
  //         change_replica && set_replica_number({name: record.name, type: record.type, scale: value.toString()});
  //       }
  //     } else {
  //       set_replica_number(undefined);
  //       init_data[num] = true;
  //       set_show_scale_warning(init_data);
  //       // set_show_scale_warning(true);
  //     }
  //   })();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [items, item_selected, set_replica_number, set_show_scale_warning, user_info.role, namespace_selected?.name, cluster_selected?.name]);

  // useEffect(() => () => { destroy_worker() }, []);

  // 当新建或者编辑时候，返回第一页
  useEffect((): void => {
    if (sort_first) {
      set_page_number(1);
    }
  }, [sort_first, set_page_number]);

  useEffect((): void => {
    (async () => {
      const response: sorter_type[] = (await get_db("sorter", list_type)) as sorter_type[];
      response && set_default_sorter(response[0]);
    })();
  }, [list_type]);

  useEffect((): void => {
    set_items([]);
  }, [set_items]);

  useEffect((): void => {
    set_expanded_keys([""]);
  }, [unit_provide]);

  useEffect(()=>{
    if(persistent_page.find((val: string) => path.includes(val))){
      const persistent_column_new: ColumnProps<row>[] = [
        {
          title: <FormattedMessage id="name" />,
          key: "name",
          sorter: (a: any, b: any) => {
              const a_name = a?.metadata?.name;
              const b_name = b?.metadata?.name;
              if (a_name && b_name) return a_name.localeCompare(b_name);
          },
          render: (item: any) => {
            return {
              children: (<span>{item?.metadata?.name}</span>),
              props: {
                "data-title": "Name: ",
              },
            };
          },
        },
        ...(list_type !== 'storage'? [{
          title: <FormattedMessage id="capacity" />,
          key: "capacity",
          // sorter: (a: any, b: any) => {
          //     const a_name = a?.spec?.capacity?.storage||'';
          //     const b_name = b?.spec?.capacity?.storage||'';
          //     if (a_name && b_name) return a_name.localeCompare(b_name);
          // },
          render: (item: any) => {
            return {
              children: (<span>{item?.spec?.capacity?.storage || item?.status?.capacity?.storage}</span>),
              props: {
                "data-title": "Capacity: ",
              },
            };
          },
        },
        {
          title: <FormattedMessage id="visit_model" />,
          key: "visit_model",
          // sorter: (a: any, b: any) => {
          //     const a_name = a?.spec?.capacity?.storage||'';
          //     const b_name = b?.spec?.capacity?.storage||'';
          //     if (a_name && b_name) return a_name.localeCompare(b_name);
          // },
          render: (item: any) => {
            return {
              children: (<span>{item?.spec?.accessModes}</span>),
              props: {
                "data-title": "Access pattern: ",
              },
            };
          }
        }]: [{
          title: <FormattedMessage id="provider"/>,
          key: "provider",
          sorter: (a: any, b: any) => {
            const a_name = a?.provisioner || '';
            const b_name = b?.provisioner || '';
            if (a_name && b_name) return a_name.localeCompare(b_name);
          },
          render: (item: any) => {
            return {
              children: (<span>{item?.provisioner}</span>),
              props: {
                "data-title": "Provider: ",
              },
            };
          }
        },
        {
          title: <FormattedMessage id="parameters"/>,
          key: "parameters",
          render: (item: any) => {
            const {parameters} = item || {parameters: {}};
            return {
              children: (parameters? Object.keys(parameters)?.map((key: string)=>(
                  <span key={key} className={'storage-parameters'}>{`${key}: ${parameters[key]}`}</span>
              )): ''),
              props: {
                "data-title": "Parameters: ",
              },
            };
          }
        }]),
        ...(list_type !== 'pvc' ? [{
          title: <FormattedMessage id="recycle_strategy" />,
          key: "recycle_strategy",
          sorter: (a: any, b: any) => {
              const a_name = a?.spec?.persistentVolumeReclaimPolicy|| a?.reclaimPolicy || '';
              const b_name = b?.spec?.persistentVolumeReclaimPolicy|| b?.reclaimPolicy || '';
              if (a_name && b_name) return a_name.localeCompare(b_name);
          },
          render: (item: any) => {
            return {
              children: (<span>{item?.spec?.persistentVolumeReclaimPolicy || item?.reclaimPolicy}</span>),
              props: {
                "data-title": "Reclaim policy: ",
              },
            };
          }
        }]: []),
        ...(list_type !== 'storage'? [{
          title: <FormattedMessage id="status" />,
          key: "status",
          sorter: (a: any, b: any) => {
              const a_name = a?.status?.phase||'';
              const b_name = b?.status?.phase||'';
              if (a_name && b_name) return a_name.localeCompare(b_name);
          },
          render: (item: any) => {
            return {
              children: (<span>{item?.status?.phase}</span>),
              props: {
                "data-title": "Status: ",
              },
            };
          },
        },
        {
          title: <FormattedMessage id="storage" />,
          key: "storage",
          render: (item: any) => {
            return {
              children: (<span>{ item?.spec?.storageClassName || 'default'}</span>),
              props: {
                "data-title": "Storage class: ",
              },
            };
          }
        }]: []),
        ...(list_type === 'pv'? [{
          title: <FormattedMessage id="pvc" />,
          key: "pvc",
          sorter: (a: any, b: any) => {
            const a_name = a?.spec?.claimRef?.name||'';
            const b_name = b?.spec?.claimRef?.name||'';
            if (a_name && b_name) return a_name.localeCompare(b_name);
          },
          render: (item:any) => {
            return {
              children: (<span>{item?.spec?.claimRef?.name || ''}</span>),
              props: {
                "data-title": "PVC: ",
              },
            };
          }
        }]: []),
        ...(list_type === 'pvc'? [{
          title: <FormattedMessage id="pv" />,
          key: "pv",
          sorter: (a: any, b: any) => {
            const a_name = a?.spec?.volumeName||'';
            const b_name = b?.spec?.volumeName||'';
            if (a_name && b_name) return a_name.localeCompare(b_name);
          },
          render: (item:any) => {
            return {
              children: (<span>{item?.spec?.volumeName || ''}</span>),
              props: {
                "data-title": "Storage volume: ",
              },
            };
          }
        }]: []),
        {
          title: formatMessage({ id: "create_time" }),
          key: 'create_time',
          render:(item: any) => {
            const create_time: any = item?.metadata?.creationTimestamp || '';
            return {
              children: (
                  <span className="font-w-7">{create_time ? format_time(create_time) : "--/--/---- --:--:--"}</span>
              ),
              props: {
                "data-title": "Create Time: ",
              },
            }
          }
        },
        {
          title: formatMessage({id: 'action'}),
          key: "action",
          width: "97px",
          fixed: "right" as any,
          render: (item: any) => {
            return {
              children: (<Dropdown
                trigger={['click']}
                placement="bottomCenter"
                overlay={<Menu>
                  <Menu.Item key={'yaml'}>
                    <div
                        className="font-9 text-center p-6"
                        onClick={() => {
                          set_table_list_modal((currentState) => ({
                            ...currentState,
                            action: 10,
                            visible: true,
                            is_yaml: true,
                            pv_yaml_data: item
                          }));
                        }}
                    >
                      <FormattedMessage id={'view_in_yaml'}/>
                    </div>
                  </Menu.Item>
                  {list_type !== 'storage' && <Menu.Item key={'delete'}>
                    <div
                        className="font-9 text-center p-6"
                        onClick={() => {
                          set_table_list_modal((currentState) => ({
                            ...currentState,
                            action: 2,
                            visible: true,
                            modal_title: `${formatMessage({id: 'delete'})} ${item?.metadata?.name}`,
                            modal_message: (<p><FormattedMessage id="delete_desc" /></p>),
                            pv_yaml_data: item
                          }))
                        }}
                    >
                      <FormattedMessage id={'delete'}/>
                    </div>
                  </Menu.Item>}
                </Menu>}
              >
                <Button className="plain_button" style={{padding: 0}}>
                  <MoreOutlined/>
                </Button>
              </Dropdown>),
              props: {
                "data-title": 'Action: ',
              },
            };
          }
        }
      ];
      set_persistent_column(persistent_column_new)
    }
    // eslint-disable-next-line
  }, [path, props.intl.messages, list_type]);

  useEffect((): void => {
    const quota_info = () => {
      return <PhysicalResourceQuotaUsage />;
    };
    const workload_info_pod = () => {
      return <WorkloadInfoPod />;
    }

    Array.isArray(items) &&
      set_table(
        path.includes("scale") || path.includes("quota") ? (
          <Table
            size="small"
            columns={workspace_column}
            dataSource={
              (items.filter((item: item) => (item?.name || "").toLocaleLowerCase().includes(search_value.toLocaleLowerCase().trim())) as unknown) as row[]
            }
            pagination={{
              pageSize: 6,
              hideOnSinglePage: true,
              showSizeChanger: false,
              defaultCurrent: page_number,
              current: page_number,
              onChange: (pageNumber: number) => {
                changePage(pageNumber);
              },
            }}
            expandedRowRender={quota_info}
            expandRowByClick
            onExpand={(expanded, record) => {
              set_table_list_modal((currentState) => ({
                ...currentState,
                quota_selected: (record.name as unknown) as string | undefined,
              }));
              if (!expanded) set_expanded_keys([""]);
              else set_expanded_keys([record.name]);
            }}
            expandIcon={({ expanded }) => (expanded ? <DownOutlined /> : <RightOutlined />)}
            expandedRowKeys={expanded_keys}
            // onChange={(_a: any, _b: any, { columnKey, order }: any) => {
            //   set_default_sorter({ columnKey, order });
            //   set_db("sorter", list_type, { columnKey, order });
            // }}
            rowKey={(workspace: row) => workspace.name}
            onRow={(record, _rowIndex) => {
              return {
                onClick: (_event) => {
                  select((record as unknown) as item, true);
                },
              };
            }}
            showSorterTooltip={false}
          />
        ) : path.includes('workloads') ? (
          <Table
            size="small"
            className={"workload_table_data" }
            columns={workspace_column}
            dataSource={
              items &&
              ((items.filter((item: item) =>
                ((path.includes("workspaces") ? item?.labels : item)?.name || "").toLocaleLowerCase().includes(search_value.toLocaleLowerCase().trim())
              ) as unknown) as row[])
            }
            pagination={{
              pageSize: 6,
              hideOnSinglePage: true,
              showSizeChanger: false,
              defaultCurrent: page_number,
              current: page_number,
              onChange: (pageNumber: number) => {
                changePage(pageNumber);
              },
            }}
            expandedRowRender={workload_info_pod}
            expandRowByClick
            onExpand={(expanded, record) => {
              // set_table_list_modal((currentState) => ({
              //   ...currentState,
              //   quota_selected: (record.name as unknown) as string | undefined,
              // }));
              if (!expanded) set_expanded_keys([""]);
              else set_expanded_keys([record.name]);
            }}
            expandIcon={({ expanded }) => expanded ? <DownOutlined className="display_none" /> : <RightOutlined className="display_none" />}
            expandedRowKeys={expanded_keys}
            rowKey={(workspace: row) => workspace.name}
            onRow={(record, _rowIndex) => {
              return {
                onClick: (_event) => {
                  select((record as unknown) as item, true);
                },
              };
            }}
            showSorterTooltip={false}
          />
        ) :  persistent_page.find((val: string) => path.includes(val)) ?
        <Table
          size="small"
            columns={persistent_column}
            dataSource={
              items &&
              ((items.filter((item: any) =>
                  (item?.metadata?.name || "").toLocaleLowerCase().includes(search_value.toLocaleLowerCase().trim())
              ) as unknown) as row[])
            }
            pagination={{
              pageSize: 6,
              hideOnSinglePage: true,
              showSizeChanger: false
            }}
            rowKey={(item: any) => item?.metadata?.name}
            showSorterTooltip={false}
            scroll={{ x: 1080}}
        />
        : (
              <Table
                size="small"
                columns={workspace_column}
                dataSource={
                  items &&
                  ((items.filter((item: item) =>
                    ((path.includes("workspaces") ? item?.labels : item)?.name || "").toLocaleLowerCase().includes(search_value.toLocaleLowerCase().trim())
                  ) as unknown) as row[])
                }
                pagination={{
                  pageSize: 6,
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                  defaultCurrent: page_number,
                  current: page_number,
                  onChange: (pageNumber: number) => {
                    changePage(pageNumber);
                  },
                }}
                rowKey={(workspace: row) => workspace.name}
                onRow={(record, _rowIndex) => {
                  return {
                    onClick: (_event) => {
                      select((record as unknown) as item, true);
                    }, // click row
                  };
                }}
                // onChange={(_a: any, _b: any, { columnKey, order }: any) => {
                //   set_default_sorter({ columnKey, order });
                //   set_db("sorter", list_type, { columnKey, order });
                // }}
                showSorterTooltip={false}
                scroll={
                  path.includes("nodes") ||
                    path.includes("workloads") ||
                    path.includes("ingress") ||
                    path.includes("scale") ||
                    path.includes("restart-alarm") ||
                    (
                      items &&
                      ((items.filter((item: item) =>
                        ((path.includes("workspaces") ? item?.labels : item)?.name || "").toLocaleLowerCase().includes(search_value.toLocaleLowerCase().trim())
                      ) as unknown) as row[])
                    )?.length === 0
                    ? {}
                    : path.includes("namespaces")
                      ? { x: 1600 }
                      : { x: 1640 }
                }
              />
            )
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, search_value, workspace_column, expanded_keys, page_number]);

  useEffect((): void => {
    set_table_list_modal((currentState: table_list_modal_type) => ({
      ...currentState,
      modal_ok_button: ["clusters", "cluster-info/workspaces", "quotas/workspace-quotas", "quotas/namespace-quotas", "workspace-info/namespaces"].includes(
        path
      ),
    }));
  }, [path, set_table_list_modal]);

  const is_not_workload: boolean = useMemo((): boolean => !(path.includes("workloads")), [path]);
  const is_not_ingress: boolean = useMemo((): boolean => !path.includes("ingress"), [path]);
  const is_not_podRestartAlarm: boolean = useMemo((): boolean => !path.includes("restart-alarm"), [path]);

  useEffect((): void => {
    if(path.includes("workspace-info/namespaces")) {
      set_wk_has_np(user_info?.roles?.filter((each: any) => {
        return each.subscriptionId ===  user_info?.subscription_id && each.clusterType === type_name && each.cluster === cluster_selected?.name && each.workspace === workspace_selected?.name && user_info?.role === "workspaceOwner" && each.roleName === "namespaceDeveloper";
       })?.length > 0 ? true : false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[ path, user_info?.roles, type_name, cluster_selected?.name, user_info?.role, workspace_selected?.name, user_info?.subscription_id, set_wk_has_np ])

  // 三點按鈕彈出選單
  useEffect((): void => {
    const is_quota: boolean = path.includes("quota");
    const menu_new: JSX.Element = !table_list_modal.visible ? (
      <Menu
        onMouseEnter={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          e.stopPropagation();
        }}
      >
        {!is_quota && !!permission[2] && !path.includes("namespaces") && !path.includes("clusters") && is_not_workload && (
          <Menu.Item>
            {/* <Popover
              content={
                <div
                  className="pointer hover p-6"
                  onClick={(e: any) => {
                    e.stopPropagation();
                    set_table_list_modal((currentState) => ({
                      ...currentState,
                      modal_title: formatMessage({ id: "edit" }),
                      action: 1,
                      visible: true,
                    }));
                  }}
                >
                  <Button className="plain_button w-100 d-flex align-items-center justify-between">
                    <span className="font-9 px-6">
                      <FormattedMessage id="edit" />
                    </span>
                    <EditOutlined />
                  </Button>
                </div>
              }
              placement="left"
              trigger="click"
            >
              <div
                className="font-9 text-center p-6"
                onClick={(e: any) => {
                  e.stopPropagation();
                }}
              >
                <FormattedMessage id="setting" />
              </div>
            </Popover> */}
            <div
              className="font-9 text-center p-6"
              onClick={(e: any) => {
                e.stopPropagation();
                set_table_list_modal((currentState) => ({
                  ...currentState,
                  modal_title: formatMessage({ id: "edit" }),
                  action: 1,
                  visible: true,
                }));
              }}
            >
              <FormattedMessage id="edit" />
            </div>
          </Menu.Item>
        )}
        {!is_quota && is_not_workload && !!permission[1] && !wk_has_np && (
          <Menu.Item>
            {/* <Popover
              content={
                list_type !== "scale" &&
                !!permission[1] && (
                  <div
                    className="pointer hover p-6"
                    onClick={(e: any) => {
                      e.stopPropagation();
                      space_delete();
                    }}
                  >
                    <Button className="plain_button w-100 d-flex align-items-center justify-between">
                      <span className="font-9 p-10">
                        <FormattedMessage id="delete" />
                      </span>
                      <DeleteFilled />
                    </Button>
                  </div>
                )
              }
              placement="left"
              trigger="click"
            >
              <div
                className="font-9 text-center p-6"
                onClick={(e: any) => {
                  e.stopPropagation();
                }}
              >
                <FormattedMessage id="status" />
              </div>
            </Popover> */}
            {
              list_type !== "scale" &&
              !!permission[1] && (
                <div
                  className="font-9 text-center p-6"
                  onClick={(e: any) => {
                    e.stopPropagation();
                    space_delete();
                  }}
                >
                  <FormattedMessage id="delete" />
                </div>
              )
            }
          </Menu.Item>
        )}
        {
          path.includes('clusters') && user_info.is_globaladmin && [
            <Menu.Item key="initialization">
              <div
                className="font-9 text-center p-6"
                onClick={(e: any) => {
                  e.stopPropagation();
                  set_table_list_modal((currentState) => ({
                    ...currentState,
                    modal_title: formatMessage({ id: "cluster_initialization" }),
                    visible: true,
                    is_initialization: true,
                  }));
                }}
              >
                <FormattedMessage id="initialization" />
              </div>
            </Menu.Item>
          ]
        }
        {!path.includes("quotas") &&
          is_not_workload &&
          is_not_ingress &&
          is_not_podRestartAlarm && [
            <Menu.Item key="config">
              <div
                className="font-9 text-center p-6"
                onClick={(e: any) => {
                  e.stopPropagation();
                  set_table_list_modal((currentState) => ({
                    ...currentState,
                    visible: true,
                    is_config: true,
                  }));
                }}
              >
                <FormattedMessage id="config" />
              </div>
            </Menu.Item>,
            <Menu.Item key="web_kubectl">
              <div
                className="font-9 text-center p-6"
                onClick={(e: any) => {
                  e.stopPropagation();
                  set_table_list_modal((currentState) => ({
                    ...currentState,
                    visible: true,
                    modal_title: formatMessage({ id: "web_kubectl" }),
                    is_web_kubectl: true,
                  }));
                }}
              >
                <FormattedMessage id="web_kubectl" />
              </div>
            </Menu.Item>,
          ]}
        {is_quota && is_not_workload && !!permission[1] && (
          <Menu.Item>
            <div
              className="pointer hover"
              onClick={(e: any) => {
                e.stopPropagation();
                space_delete();
              }}
            >
              <Button className="plain_button w-100 d-flex align-items-center justify-between">
                <span className="font-9 p-10">
                  <FormattedMessage id="delete" />
                </span>
                <DeleteFilled />
              </Button>
            </div>
          </Menu.Item>
        )}
        {!is_quota && is_not_workload && !path.includes("clusters") && !!permission[4] && (
          <Menu.Item>
            <div
              className="font-9 text-center p-6"
              onClick={(e: any) => {
                e.stopPropagation();
                const position: number = path.lastIndexOf("/") + 1,
                  list_type: string = path.substr(position, path.length - position - 1);
                props.history.push(`/${list_type}/scale`);
              }}
            >
              <FormattedMessage id="scale" />
            </div>
          </Menu.Item>
        )}
        {!is_quota && is_not_workload && is_not_ingress && is_not_podRestartAlarm && (
          <Menu.Item>
            <Link
              className="font-9 text-center p-6"
              onClick={(e: any) => {
                e.stopPropagation();
                set_workspace_selected(item_selected);
              }}
              to="/monitor/kubernetes"
            >
              <FormattedMessage id="monitor" />
            </Link>
          </Menu.Item>
        )}
        {!is_not_workload && [
          // <Menu.Item key="log">
          //   <div
          //     className="font-9 text-center p-6"
          //     onClick={(e: any) => {
          //       e.stopPropagation();
          //       set_table_list_modal((currentState) => ({
          //         ...currentState,
          //         visible: true,
          //         is_logs: true,
          //       }));
          //     }}
          //   >
          //     <FormattedMessage id="log" />
          //   </div>
          // </Menu.Item>,
          <Menu.Item className="text-center no_btn_bg" key="scale">
            <Button
              className="text-center p-6"
              type="text"
              disabled={item_selected.type?.toLocaleLowerCase() === 'deployment' || item_selected.type?.toLocaleLowerCase() === 'statefulset' ? false : true}
              onClick={(e: any) => {
                e.stopPropagation();
                set_table_list_modal((currentState) => ({
                  ...currentState,
                  visible: true,
                  modal_title: formatMessage({id: 'scale'}),
                  is_scale_replica: true,
                }));
              }}
            >
              <FormattedMessage id="scale" />
            </Button>
          </Menu.Item>,
          <Menu.Item key="edit_yaml">
            <div
              className="font-9 text-center p-6"
              onClick={(e: any) => {
                e.stopPropagation();
                set_table_list_modal((currentState) => ({
                  ...currentState,
                  visible: true,
                  modal_title: formatMessage({ id: "edit_yaml" }),
                  is_edit_yaml: true,
                  is_view_yaml: false,
                  is_sure_edit: false,
                  origin: 'workload',
                }));
              }}
            >
              <FormattedMessage id="edit_yaml" />
            </div>
          </Menu.Item>,
          <Menu.Item key="view_yaml">
            <div
              className="font-9 text-center p-6"
              onClick={(e: any) => {
                e.stopPropagation();
                set_table_list_modal((currentState) => ({
                  ...currentState,
                  visible: true,
                  modal_title: formatMessage({ id: "view_yaml" }),
                  is_view_yaml: true,
                  is_edit_yaml: false,
                  origin: 'workload',
                }));
              }}
            >
              <FormattedMessage id="view_yaml" />
            </div>
          </Menu.Item>,
          <Menu.Item key="log">
            <div
              className="font-9 text-center p-6"
              onClick={(e: any) => {
                e.stopPropagation();
                set_table_list_modal((currentState) => ({
                  ...currentState,
                  visible: true,
                  is_logs: true,
                }));
              }}
            >
              <FormattedMessage id="log" />
            </div>
          </Menu.Item>,
        ]}
        {
          !is_not_podRestartAlarm && [
            <Menu.Item key="log">
              <div
                className="font-9 text-center p-6"
                onClick={(e: any) => {
                  e.stopPropagation();
                  set_table_list_modal((currentState) => ({
                    ...currentState,
                    visible: true,
                    is_restartLogs: true,
                    modal_title: formatMessage({ id: "log" }),
                  }));
                }}
              >
                <FormattedMessage id="log" />
              </div>
            </Menu.Item>,
            <Menu.Item>
              <Link
                className="font-9 text-center p-6"
                onClick={(e: any) => {
                  e.stopPropagation();
                  set_workspace_selected(item_selected);
                }}
                to="/monitor/kubernetes"
              >
                <FormattedMessage id="monitor" />
              </Link>
            </Menu.Item>
          ]
        }
        {!is_not_ingress && !!permission[5] && (
          <Menu.Item>
            <div
              className="font-9 text-center p-6"
              onClick={(e: any) => {
                e.stopPropagation();
                set_table_list_modal((currentState) => ({
                  ...currentState,
                  visible: true,
                  is_details: true,
                }));
              }}
            >
              <FormattedMessage id="details" />
            </div>
          </Menu.Item>
        )}
        {!is_not_ingress && !!permission[6] && (
          <Menu.Item>
            <div
              className="font-9 text-center p-6"
              onClick={(e: any) => {
                e.stopPropagation();
                set_table_list_modal((currentState) => ({
                  ...currentState,
                  action: 1,
                  visible: true,
                  is_yaml: true,
                }));
              }}
            >
              <FormattedMessage id="view_in_yaml" />
            </div>
          </Menu.Item>
        )}
      </Menu>
    ) : (
        <Fragment></Fragment>
      );
    set_menu(menu_new);
  }, [
    formatMessage,
    is_not_workload,
    is_not_ingress,
    is_not_podRestartAlarm,
    item_selected,
    list_type,
    path,
    permission,
    props,
    set_workspace_selected,
    space_delete,
    table_list_modal.visible,
    set_table_list_modal,
    user_info.is_globaladmin,
    wk_has_np,
  ]);

  useEffect((): void => {
    const show_usage: boolean = !path.includes("quota") && !path.includes("workloads") && !path.includes("ingress") && !path.includes("restart-alarm");
    const is_dedicate_cluster: boolean = path.includes("clusters") && (type_name === "dedicate" || sessionStorage.getItem("cluster_type") === "dedicate");
    const is_general_workspace: boolean = path.includes("workspaces") && (type_name === "shared" || sessionStorage.getItem("cluster_type") === "shared");
    const timezone_num: number = -(new Date().getTimezoneOffset() / 60),
      timezone: string = ` (GMT${timezone_num < 0 ? "" : "+"}${timezone_num})`,
      quota_table_title =
        path.includes("quota") || path.includes("scale")
          ? ["name", "limitCPU", "limitMemory", "limitsRootfs", "limitsDisk", "pods", "gpu", "persistentvolumeclaims", "services", "secrets", "configmaps"]
          : path.includes("ingress")
            ? ["internalDomain", "externalDomain", "path", "serviceName", "servicePort", "creationTimestamp"]
            : path.includes("workloads")
              ? ["type", "create_time", "ready_total"]
              : [];
    const quota_table_columns = quota_table_title?.map((quota_title) => ({
      title: `${
        quota_title === "name"
          ? formatMessage({ id: "name" })
          : quota_title === "type"
            ? formatMessage({ id: "type" })
            : quota_title === "create_time"
              ? formatMessage({ id: "create_time" })
              : quota_title === "ready_total"
                ? formatMessage({ id: "ready_total" })
                : quota_title === "internalDomain"
                  ? formatMessage({ id: "internal_domain" })
                  : quota_title === "externalDomain"
                    ? formatMessage({ id: "external_domain" })
                    : quota_title === "path"
                      ? formatMessage({ id: "path" })
                      : quota_title === "serviceName"
                        ? formatMessage({ id: "svc" })
                        : quota_title === "servicePort"
                          ? formatMessage({ id: "port" })
                          : quota_title === "creationTimestamp"
                            ? formatMessage({ id: "created_at" })
                            : quota_title === 'gpu'
                              ? 'GPU'
                                : quota_title === "persistentvolumeclaims"
                                  ? "PVC"
                                  : quota_title === "configmaps"
                                    ? "ConfigMaps"
                                    : quota_title === "limitCPU"
                                      ? "LimitsCPU"
                                      : quota_title === "limitMemory"
                                        ? "LimitsMemory"
                                        : quota_title === "limitsRootfs"
                                          ? "LimitsRootfs"
                                          : quota_title === "limitsDisk"
                                            ? "PVC Disk"
                                            : key_to_title(quota_title)
        } ${
        quota_title === "limitCPU"
          ? "(Core)"
          : quota_title === "limitMemory" || quota_title === "limitsRootfs" || quota_title === "limitsDisk"
            ? `(${unit_provide})`
            : ""
        }`,
      dataIndex: quota_title,
      key: quota_title,
      sorter:
        quota_title === "internalDomain"
          ? false
          : quota_title === "externalDomain"
            ? false
            : quota_title === "path"
              ? false
              : quota_title === "serviceName"
                ? false
                : quota_title === "servicePort"
                  ? false
                  : quota_title === "ready_total"
                    ? false
                    : (a: any, b: any) => {
                      switch (quota_title) {
                        case "name":
                        case "type":
                        case "create_time":
                        case "creationTimestamp":
                          return a[quota_title] && b[quota_title] && a[quota_title].localeCompare(b[quota_title]);
                        case "status":
                          return a.status.ready - b.status.ready || a.status.total - b.status.total;
                        case "limitCPU":
                          const a_limit_cpu: number = a && a.limitsCPU ? (a.limitsCPU === "Unlimited" ? Infinity : Number(a.limitsCPU)) : Infinity;
                          const b_limit_cpu: number = b && a.limitsCPU ? (b.limitsCPU === "Unlimited" ? Infinity : Number(b.limitsCPU)) : Infinity;
                          return a_limit_cpu - b_limit_cpu;
                        case "limitMemory":
                          const a_limit_memory: number = a && a.limitMemory ? (a.limitMemory === "*" ? Infinity : Number(a.limitMemory)) : Infinity;
                          const b_limit_memory: number = b && b.limitMemory ? (b.limitMemory === "*" ? Infinity : Number(b.limitMemory)) : Infinity;
                          return a_limit_memory - b_limit_memory;
                        case "limitsRootfs":
                          const a_limit_rootfs: number = a && a.limitsRootfs ? (a.limitsRootfs === "Unlimited" ? Infinity : Number(a.limitsRootfs)) : Infinity;
                          const b_limit_rootfs: number = b && b.limitsRootfs ? (b.limitsRootfs === "Unlimited" ? Infinity : Number(b.limitsRootfs)) : Infinity;
                          return a_limit_rootfs - b_limit_rootfs;
                        case "limitsDisk":
                          const a_limit_disk: number = a && a.limitsDisk ? (a.limitsDisk === "Unlimited" ? Infinity : Number(a.limitsDisk)) : Infinity;
                          const b_limit_disk: number = b && b.limitsDisk ? (b.limitsDisk === "Unlimited" ? Infinity : Number(b.limitsDisk)) : Infinity;
                          return a_limit_disk - b_limit_disk;
                        case "pods":
                          const a_pod: number = a && a.pods ? (a.pods === "Unlimited" ? Infinity : Number(a.pods)) : Infinity;
                          const b_pod: number = b && b.pods ? (b.pods === "Unlimited" ? Infinity : Number(b.pods)) : Infinity;
                          return a_pod - b_pod;
                        case "gpu":
                          const a_limit_gpu: number = a && a.gpu ? (a.gpu === "Unlimited" ? Infinity : Number(a.gpu)) : Infinity;
                          const b_limit_gpu: number = b && b.gpu ? (b.gpu === "Unlimited" ? Infinity : Number(b.gpu)) : Infinity;
                          return a_limit_gpu - b_limit_gpu;
                        case "persistentvolumeclaims":
                          const a_limit_pvc: number =
                            a && a.persistentvolumeclaims ? (a.persistentvolumeclaims === "Unlimited" ? Infinity : a.persistentvolumeclaims) : Infinity;
                          const b_limit_pvc: number =
                            b && b.persistentvolumeclaims ? (b.persistentvolumeclaims === "Unlimited" ? Infinity : b.persistentvolumeclaims) : Infinity;
                          return a_limit_pvc - b_limit_pvc;
                        case "services":
                          const a_limit_services: number = a && a.services ? (a.services === "Unlimited" ? Infinity : a.services) : Infinity;
                          const b_limit_services: number = b && b.services ? (b.services === "Unlimited" ? Infinity : b.services) : Infinity;
                          return a_limit_services - b_limit_services;
                        case "secrets":
                          const a_limit_secrets: number = a && a.secrets ? (a.secrets === "Unlimited" ? Infinity : a.secrets) : Infinity;
                          const b_limit_secrets: number = b && b.secrets ? (b.secrets === "Unlimited" ? Infinity : b.secrets) : Infinity;
                          return a_limit_secrets - b_limit_secrets;
                        case "configmaps":
                          const a_limit_configmaps: number = a && a.configmaps ? (a.configmaps === "Unlimited" ? Infinity : a.configmaps) : Infinity;
                          const b_limit_configmaps: number = b && b.configmaps ? (b.configmaps === "Unlimited" ? Infinity : b.configmaps) : Infinity;
                          return a_limit_configmaps - b_limit_configmaps;
                        default:
                          return;
                      }
                    },
      render: (item: any) => {
        let children: JSX.Element | string;
        switch (quota_title) {
          case "name":
            children = (
              <span onClick={(e) => e.stopPropagation()}>
                <Text className="font-w-7 text_color" copyable={{ text: item }}>
                  {item}
                </Text>
              </span>
            );
            break;

          case "limitMemory":
          case "limitsDisk":
          case "limitsRootfs":
            children = item !== undefined ? (item === "Unlimited" ? "Unlimited" : change_unit(item, unit_provide, false).toFixed(2)) : "Unlimited";
            break;

          case "create_time":
            children = item && Number(item) ? formatDate(Number(item)) : "--/--/---- --:--:--";
            break;

          case "ready_total":
            children = `${item.ready} Ready / ${item.total} Total`;
            break;

          case "internalDomain":
            children = Array.isArray(item)
              ? item.map((item_each: any, num: number) => {
                return (
                  Array.isArray(item_each.http.paths) &&
                  item_each.http.paths.map((path: any, index: number) => <div key={item_each.host + num + index}>{item_each.host}</div>)
                );
              })
              : item;
            break;

          case "externalDomain":
            children = Array.isArray(item)
              ? item.map((item_each: any, num: number) => {
                return (
                  Array.isArray(item_each.http.paths) &&
                  item_each.http.paths.map((path: any, index: number) => (
                    <Text key={item_each.host + num + index} copyable={{ text: `https://${item_each.external}` }} style={{ display: "block" }}>
                      <a href={`https://${item_each.external}`} target="_blank" rel="noopener noreferrer">
                        https://{item_each.external}
                      </a>
                    </Text>
                  ))
                );
              })
              : item;
            break;

          case "path":
            children = Array.isArray(item)
              ? item.map((item_each: any, num: number) => {
                return (
                  Array.isArray(item_each.http.paths) &&
                  item_each.http.paths.map((path: any, index: number) => <div key={path.path + num + index}>{path.path}</div>)
                );
              })
              : item;
            break;

          case "serviceName":
            children = Array.isArray(item)
              ? item.map((item_each: any, num: number) => {
                return (
                  Array.isArray(item_each.http.paths) &&
                  item_each.http.paths.map((path: any, index: number) => <div key={`${path.backend.serviceName ? path.backend.serviceName : path.backend.service.name}` + num + index}>{path.backend.serviceName ? path.backend.serviceName : path.backend.service.name}</div>)
                );
              })
              : item;
            break;

          case "servicePort":
            children = Array.isArray(item)
              ? item.map((item_each: any, num: number) => {
                return (
                  Array.isArray(item_each.http.paths) &&
                  item_each.http.paths.map((path: any, index: number) => <div key={`${path.backend.servicePort ? path.backend.servicePort : path.backend.service.port.number}` + num + index}>{path.backend.servicePort ? path.backend.servicePort : path.backend.service.port.number}</div>)
                );
              })
              : item;
            break;

          case "creationTimestamp":
            children = get_time(item);
            break;

          case "gpu":
            children = item !== undefined && item !== "" ? item : 0;
            break;

          default:
            children = item !== undefined && item !== "" ? item : "Unlimited";
            break;
        }
        return {
          children,
          props: {
            "data-title": `${key_to_title(quota_title)} ${
              quota_title === "internalDomain"
                ? "Internal Domain"
                : quota_title === "externalDomain"
                  ? "External Domain"
                  : quota_title === "servicePort"
                    ? "Port"
                    : quota_title === "serviceName"
                      ? "SVC"
                      : quota_title === "createTime"
                        ? "Created At"
                        : quota_title === "limitCPU"
                          ? "(Core)"
                          : quota_title === "limitMemory" || quota_title === "limitsRootfs" || quota_title === "limitsDisk" || quota_title === "persistentvolumeclaims"
                            ? `(${unit_provide})`
                            : ""
              }: `,
          },
        };
      },
    }));

    const workspace_column_new: ColumnProps<row>[] = [
      ...(path.includes("scale")
        ? quota_table_columns
        : [
          ...(
            path.includes("clusters") && !table_list_modal.is_logs ?
              [
                {
                  title: (<Fragment>
                    <span><FormattedMessage id="cluster" /></span>
                    <br />
                    <span>
                      <FormattedMessage id="status" />
                    </span>
                  </Fragment>),
                  dataIndex: "agentstatus",
                  width: 80,
                  fixed: "left",
                  key: "agentstatus",
                  render: (agentstatus: { status?: string; agentStatus?: string }) => {
                    const status_value: string = agentstatus?.status || '';
                    const agentStatus_value: string = agentstatus?.agentStatus || '';
                    return {
                      children:
                        (
                          <span>
                            {
                              status_value?.toLocaleLowerCase() === "active" && agentStatus_value?.toLocaleLowerCase() === "active" ?
                                <Tooltip title={
                                  <Fragment>
                                    <div style={{ borderBottom: '0.5px solid #676767' }}>Cluster Status: Ready</div>
                                    <div>Details:</div>
                                    <div className="ml-10">
                                      <div>
                                        APIServer Status: {status_value}
                                      </div>
                                      <div>
                                        ClusterAgent Status: {agentStatus_value}
                                      </div>
                                    </div>
                                  </Fragment>
                                }>
                                  <img src={active_circle} alt="Ready" className="height_16" />
                                </Tooltip>
                                :
                                (status_value?.toLocaleLowerCase() === "offline" && agentStatus_value?.toLocaleLowerCase() === "offline" ?
                                  <Tooltip title={
                                    <Fragment>
                                      <div style={{ borderBottom: '0.5px solid #676767' }}>Cluster Status: Offline</div>
                                      <div>Details:</div>
                                      <div className="ml-10">
                                        <div>
                                          APIServer Status: {status_value}
                                        </div>
                                        <div>
                                          ClusterAgent Status: {agentStatus_value}
                                        </div>
                                      </div>
                                    </Fragment>
                                  }>
                                    <img src={offline_circle} alt="Offline" className="height_16" />
                                  </Tooltip> :
                                  (((status_value?.toLocaleLowerCase() === "active" && agentStatus_value?.toLocaleLowerCase() === "offline") || (status_value?.toLocaleLowerCase() === "offline" && agentStatus_value?.toLocaleLowerCase() === "active")) ?
                                    <Tooltip placement="topLeft" title={<Fragment>
                                      <div style={{ borderBottom: '0.5px solid #676767' }}>Cluster Status: NotReady</div>
                                      <div>Details:</div>
                                      <div className="ml-10">
                                        <div>
                                          APIServer Status: {status_value}
                                        </div>
                                        <div>
                                          ClusterAgent Status: {agentStatus_value}
                                        </div>
                                      </div>
                                    </Fragment>
                                    }>
                                      <img src={warning_circle} alt="NotReady" className="height_16" />
                                    </Tooltip> :
                                    <Tooltip placement="topLeft" title={<Fragment>
                                      <div style={{ borderBottom: '0.5px solid #676767' }}>Cluster Status: NotAvailable</div>
                                    </Fragment>
                                    }>
                                      <img src={fail_circle} alt="unvalid" className="height_16" />
                                    </Tooltip>
                                  )
                                )
                            }
                          </span>
                        ),
                      props: {
                        "data-title": "ClusterStatus: ",
                      },
                    };
                  },
                },
              ] :
            (path.includes("workspaces") || path.includes("namespaces")) && !table_list_modal.is_logs ?
                [
                  {
                    title: <FormattedMessage id="status" />,
                    dataIndex: "status",
                    width: 73,
                    fixed: "left",
                    key: "status",
                    render: (status: any) => {
                      return {
                        children:
                          status?.toLocaleLowerCase() === "active" ? (
                            <Tooltip title="Active">
                              <img src={active_circle} alt="Active" className="height_16" />
                            </Tooltip>
                          ) : (
                              <Tooltip title="Stopped">
                                <img src={offline_circle} alt="Stopped" className="height_16" />
                              </Tooltip>
                            ),
                        props: {
                          "data-title": "Status: ",
                        },
                      };
                    },
                  },
                ]
            : ([] as any)),
          ...(path.includes('workloads') ? [
            { 
            title: '',
            dataIndex: 'name',
            width: 48,
            key: 'expanded_icon',
            render:(name: any) => {
              return {
                children: (
                  <span>
                    {
                      expanded_keys[0] === name ? <DownOutlined /> : <RightOutlined />
                    }
                  </span>
                ),
                props: {
                  "data-title": "icon: ",
                },
              }
            }
          },
          ] : []),
          ...(path.includes("scale") || path.includes("quotas") || path.includes("restart-alarm")
            ? []
            : [
              {
                title: <FormattedMessage id="name" />,
                dataIndex: "name",
                key: "name",
                width: `${path.includes("workloads") || path.includes("ingress") ? "" : "135px"}`,
                fixed: `${
                  path.includes("nodes") || path.includes("workloads") || path.includes("ingress") ? "false" : "left"
                  }`,
                className: "link_title",
                sorter: (a: any, b: any) => {
                  if (path.includes("workspaces") && Array.isArray(workspaces)) {
                    const a_name = workspaces?.find((workspace) => workspace?.metadata?.name === a.name)?.metadata?.labels?.name;
                    const b_name = workspaces?.find((workspace) => workspace?.metadata?.name === b.name)?.metadata?.labels?.name;
                    if (a_name && b_name) {
                      return a_name.localeCompare(b_name);
                    } else return a.name.localeCompare(b.name);
                  } else {
                    return a.name.localeCompare(b.name);
                  }
                },
                // sortOrder: default_sorter ? default_sorter.columnKey === "name" && default_sorter.order : 'false',
                render: (name: any) => {
                  const position: number = path.lastIndexOf("/") + 1,
                    list_type: string = path.substr(position, path.length - position - 1).replace(/-/gi, "");
                  return {
                    children: (
                      <Col sm={24} className="font-w-7">
                        {!path.includes("nodes") &&
                          !path.includes("storage-classes") &&
                          !path.includes("quotas") &&
                          !path.includes("scale") &&
                          !path.includes("workloads") &&
                          !path.includes("ingress") &&
                          !table_list_modal.is_logs ? (
                            <Link to={`/${list_type}-info/overview`} className="font-w-7">
                              {path.includes("workspaces")
                                ? Array.isArray(workspaces)
                                  ? workspaces?.find((workspace) => workspace?.metadata?.name === name)?.metadata?.labels?.name
                                  : ""
                                : name}
                            </Link>
                          ) : (
                            name
                          )}
                        <span onClick={(e) => e.stopPropagation()}>
                          <Text
                            copyable={{
                              text: `${
                                path.includes("workspaces")
                                  ? Array.isArray(workspaces)
                                    ? workspaces?.find((workspace) => workspace?.metadata?.name === name)?.metadata?.labels?.name
                                    : ""
                                  : name
                                }`,
                            }}
                          ></Text>
                        </span>
                      </Col>
                    ),
                    props: {
                      "data-title": "Name: ",
                    },
                  };
                },
              },
            ]),
            ...(path.includes("restart-alarm")
            ? [
              {
                title: <FormattedMessage id="pod" />,
                dataIndex: "name",
                key: "name",
                width: "",
                fixed: `${"false"}`,
                sorter: (a: any, b: any) => { a.name.localeCompare(b.name); },
                render: (name: any) => {
                  return {
                    children: (
                      <Col sm={24} className="font-w-7">
                        {name}
                        <span onClick={(e) => e.stopPropagation()}>
                          <Text
                            copyable={{
                              text: `${name
                                }`,
                            }}
                          ></Text>
                        </span>
                      </Col>
                    ),
                    props: {
                      "data-title": "Name: ",
                    },
                  };
                },
              },
            ] : []),
          ...(path.includes("clusters")
            ? [
              {
                title: <FormattedMessage id="version" />,
                dataIndex: "version",
                key: "version",
                width: "100px",
                className: "link_title",
                sorter: (a: any, b: any) => a.name.localeCompare(b.name),
                // sortOrder: default_sorter ? default_sorter.columnKey === "version" && default_sorter.order : 'false',
                render: (version: any) => {
                  return {
                    children: <Col sm={24} className="font-w-7">{version}</Col>,
                    props: {
                      "data-title": "Version: ",
                    },
                  };
                },
              },
            ]
            : []),
          ...(path.includes("workspaces") && (!path.includes("workspaces") || user_info.role !== "namespaceDeveloper")
            ? [
              {
                title: <FormattedMessage id="namespaces" />,
                dataIndex: "totalNamespaces",
                key: "totalNamespaces",
                width: "130px",
                sorter: (a: any, b: any) => {
                  const a_namespaces: number = Number(a.totalNamespaces);
                  const b_namespaces: number = Number(b.totalNamespaces);
                  return a_namespaces - b_namespaces;
                },
                // sortOrder: default_sorter ? default_sorter.columnKey === "totalNamespaces" && default_sorter.order : 'false',
                render: (totalNamespaces: string | number, item: item) => {
                  return totalNamespaces
                    ? {
                      children: (
                        <Col
                          className="font-w-7"
                          sm={24}
                          onClick={(e) => {
                            e.stopPropagation();
                            set_workspace_selected(item);
                            item?.name && sessionStorage.setItem("workspace", item?.name);
                            props.history.push("/workspace-info/namespaces");
                          }}
                        >
                          <Link to="#" className="text_color">
                            {totalNamespaces}
                          </Link>
                        </Col>
                      ),
                      props: {
                        "data-title": "Namepsaces",
                      },
                    }
                    : {};
                },
              },
            ]
            : []),
          // ...(path.includes("storage-classes")
          //   ? [
          //       {
          //         title: "Parameters",
          //         dataIndex: "parameters",
          //         key: "parameters",
          //         sorter: false,
          //         render: (parameters: { [key: string]: string }) => {
          //           return {
          //             children: (
          //               <Descriptions bordered size="small">
          //                 {Object.keys(parameters).map((key: string) => {
          //                   const value = parameters[key];
          //                   return (
          //                     <Descriptions.Item label={key} key={key} className="w-120 text-ellipsis w-max-100">
          //                       <span title={value}>{value}</span>
          //                     </Descriptions.Item>
          //                   );
          //                 })}
          //               </Descriptions>
          //             ),
          //             props: {
          //               "data-title": `Parameters: `,
          //             },
          //           };
          //         },
          //       },
          //     ]
          //   :
          ...(path.includes("workspaces") && user_info.role === "namespaceDeveloper"
            ? []
            : [
              ...(!path.includes("nodes") && !path.includes("storage-classes") && show_usage && (is_general_workspace || is_dedicate_cluster)
                ? [
                  {
                    title: <FormattedMessage id="active_time" values={{ time: <span> {timezone}</span> }} />,
                    dataIndex: "createTime",
                    width: "101px",
                    key: "createTime",
                    sorter: (a: item, b: item) => {
                      const a_active = a.createTime && Number(a.createTime) ? formatDate(Number(a.createTime)) : "--/--/---- --:--:--";
                      const b_active = b.createTime && Number(b.createTime) ? formatDate(Number(b.createTime)) : "--/--/---- --:--:--";
                      let a_time = new Date(a_active).getTime();
                      let b_time = new Date(b_active).getTime();
                      return a_time - b_time;
                    },
                    // sortOrder: default_sorter ? default_sorter.columnKey === "creationTimestamp" && default_sorter.order : 'false',
                    render: (avtiveTime: string) => {
                      return {
                        children: (
                          <span className="font-w-7">{avtiveTime && Number(avtiveTime) ? formatDate(Number(avtiveTime)) : "--/--/---- --:--:--"}</span>
                        ),
                        props: {
                          "data-title": `Active Time${timezone}: `,
                        },
                      };
                    },
                  },
                ]
                : []),
              ...(path.includes("restart-alarm")
                ? [
                    {
                      title: <FormattedMessage id="container" />,
                      dataIndex: "container",
                      key: "container",
                      // width: "220px",
                      // sorter: (a: any, b: any) => a.name.localeCompare(b.name),
                      // sortOrder: default_sorter ? default_sorter.columnKey === "version" && default_sorter.order : 'false',
                      render: (container: any) => {
                        return {
                          children: <Col sm={24} className="font-w-7">{container}</Col>,
                          props: {
                            "data-title": "Container: ",
                          },
                        };
                      },
                    },
                    {
                      title: <FormattedMessage id="type" />,
                      dataIndex: "type",
                      key: "type",
                      // width: "140px",
                      // sorter: (a: any, b: any) => a.name.localeCompare(b.name),
                      // sortOrder: default_sorter ? default_sorter.columnKey === "version" && default_sorter.order : 'false',
                      render: (type: any) => {
                        return {
                          children: <Col sm={24} className="font-w-7">{type}</Col>,
                          props: {
                            "data-title": "Type: ",
                          },
                        };
                      },
                    },
                    {
                      title: <FormattedMessage id="restart_time" values={{ time: <span> {timezone}</span> }} />,
                      dataIndex: "updateTime",
                      // width: `${path.includes("restart-alarm") ? "140px" : "101px"}`,
                      key: "updateTime",
                      sorter: (a: item, b: item) => {
                        const a_update = a.updateTime && Number(a.updateTime) ? formatDate(Number(a.updateTime)) : "--/--/---- --:--:--";
                        const b_update = b.updateTime && Number(b.updateTime) ? formatDate(Number(b.updateTime)) : "--/--/---- --:--:--";
                        let a_time = new Date(a_update).getTime();
                        let b_time = new Date(b_update).getTime();
                        return a_time - b_time;
                      },
                      // sortOrder: default_sorter ? default_sorter.columnKey === "updateTime" && default_sorter.order : 'false',
                      render: (updateTime: string) => {
                        return {
                          children: (
                            <span className="font-w-7">{updateTime && Number(updateTime) ? formatDate(Number(updateTime)) : "--/--/---- --:--:--"}</span>
                          ),
                          props: {
                            "data-title": `Update Time${timezone}: `,
                          },
                        };
                      },
                    },
                ]
                : []),
              ...(!path.includes("nodes") && !path.includes("storage-classes") && show_usage
                ? [
                  {
                    title: <FormattedMessage id="update_time" values={{ time: <span> {timezone}</span> }} />,
                    dataIndex: "updateTime",
                    width: "101px",
                    key: "updateTime",
                    sorter: (a: item, b: item) => {
                      const a_update = a.updateTime && Number(a.updateTime) ? formatDate(Number(a.updateTime)) : "--/--/---- --:--:--";
                      const b_update = b.updateTime && Number(b.updateTime) ? formatDate(Number(b.updateTime)) : "--/--/---- --:--:--";
                      let a_time = new Date(a_update).getTime();
                      let b_time = new Date(b_update).getTime();
                      return a_time - b_time;
                    },
                    // sortOrder: default_sorter ? default_sorter.columnKey === "updateTime" && default_sorter.order : 'false',
                    render: (updateTime: string) => {
                      return {
                        children: (
                          <span className="font-w-7">{updateTime && Number(updateTime) ? formatDate(Number(updateTime)) : "--/--/---- --:--:--"}</span>
                        ),
                        props: {
                          "data-title": `Update Time${timezone}: `,
                        },
                      };
                    },
                  },
                ]
                : []),
              ...(path.includes("clusters")
                ? [
                  {
                    title: <FormattedMessage id="node" />,
                    dataIndex: "node",
                    key: "node",
                    width: "80px",
                    textWrap: "word-break",
                    ellipsis: true,
                    className: "link_title",
                    sorter: (a: any, b: any) => a.name.localeCompare(b.name),
                    // sortOrder: default_sorter ? default_sorter.columnKey === "node" && default_sorter.order : 'false',
                    render: (node: any) => {
                      return {
                        children: <Col sm={24} className="font-w-7">{node}</Col>,
                        props: {
                          "data-title": "Node: ",
                        },
                      };
                    },
                  },
                ]
                : []),
              ...(path.includes("scale") || path.includes("quota") || path.includes("workloads") || path.includes("ingress") || path.includes("restart-alarm")
                ? quota_table_columns
                : [
                  ...(path.includes("nodes")? [{
                    title: <FormattedMessage id="node_type" />,
                    dataIndex: 'nodeType',
                    key: "nodeType",
                    width: "100px",
                    ellipsis: true,
                    sorter: (a: any, b: any) => a.name.localeCompare(b.name),
                    render: (data: any) => {
                      return {
                        children: <Col sm={24} className="font-w-7">{(data || 'cpu').toUpperCase()}</Col>,
                        props: {
                          "data-title": "Node: ",
                        },
                      };
                    }
                  }]:[]),
                  {
                    title: (
                      <Fragment>
                        CPU (Core)
                        <br />
                        <span className="font-gray">
                          <FormattedMessage id="request_limit" />
                        </span>
                      </Fragment>
                    ),
                    dataIndex: "cpu",
                    key: "cpu",
                    className: "text-ellipsis font-w-6",
                    width: `${path.includes("nodes") || path.includes("namespaces") ? "176px" : "160px"}`,
                    // sorter: (a: item, b: item) => {
                    //   const request_cpu_a: number = Number(a?.cpu?.requestCPU) || 0,
                    //     total_cpu_a: number = Number(a?.cpu?.totalCPU === "*" ? -1 : a?.cpu?.totalCPU),
                    //     limits_cpu_a: number = Number(a?.cpu?.limitCPU === "*" ? -1 : a?.cpu?.limitCPU),
                    //     request_cpu_b: number = Number(b?.cpu?.requestCPU) || 0,
                    //     total_cpu_b: number = Number(b?.cpu?.totalCPU === "*" ? -1 : b?.cpu?.totalCPU),
                    //     limits_cpu_b: number = Number(b?.cpu?.limitCPU === "*" ? -1 : b?.cpu?.limitCPU);
                    //   return total_cpu_a < 0 || limits_cpu_a < 0
                    //     ? 1
                    //     : request_cpu_a / total_cpu_a - request_cpu_b / total_cpu_b || limits_cpu_a / total_cpu_a - limits_cpu_b / total_cpu_b || -1;
                    // },
                    // sortOrder: default_sorter ? default_sorter.columnKey === "cpu" && default_sorter.order : 'false',
                    render: (cpu: { requestCPU?: string; totalCPU?: string; limitCPU?: string }) => {
                      const request_cpu: number = Number(cpu?.requestCPU) || 0,
                        total_cpu: number = Number(cpu?.totalCPU === "*" ? -1 : cpu?.totalCPU),
                        limits_cpu: number = Number(cpu?.limitCPU === "*" ? -1 : cpu?.limitCPU) || 0;
                      return {
                        children: (
                          <Row className={`${path.includes("nodes") ? "min_width_166" : "min_width_144"}`}>
                            <div className="font-w-7 width_48 hidden" style={{ textOverflow: "ellipsis" }}>
                              {request_cpu.toFixed(2)}
                            </div>
                            {show_usage && (
                              <Col sm={10} className="ml-5">
                                <Progress
                                  percent={(Number(request_cpu) / Number(total_cpu)) * 100}
                                  strokeWidth={8}
                                  strokeColor={theme === "dark_blue" ? "#2E7BBF" : theme === "black_gray" ? "#6c748b" : "#4fa1e8"}
                                  showInfo={false}
                                />
                              </Col>
                            )}
                            <div className="font-w-7 width_48 hidden" style={{ textOverflow: "ellipsis" }}>
                              {limits_cpu === -1 ? 'Unlimited' : limits_cpu.toFixed(2)}
                            </div>
                            {show_usage && (
                              <Col sm={10} className="ml-5">
                                <Progress
                                  percent={(Number(limits_cpu) / Number(total_cpu)) * 100}
                                  strokeWidth={8}
                                  strokeColor={theme === "dark_blue" ? "#2E7BBF" : theme === "black_gray" ? "#6c748b" : "#4fa1e8"}
                                  showInfo={false}
                                />
                              </Col>
                            )}
                          </Row>
                        ),
                        props: {
                          "data-title": "Request/Limit of CPU: ",
                        },
                      };
                    },
                  },
                  {
                    title: (
                      <Fragment>
                        CPU (Core)
                        <br />
                        <span className="font-gray">
                          <FormattedMessage id="usage_quota" />
                        </span>
                      </Fragment>
                    ),
                    dataIndex: "cpu",
                    width: `${!path.includes("nodes") ? "130px" : ""}`,
                    key: "cpuUsage",
                    className: "text-ellipsis font-w-6",
                    sorter: (a: item, b: item) => {
                      const used_cpu_a: number = Number(a?.cpu?.usedCPU) || 0,
                        total_cpu_a: number = Number(a?.cpu?.totalCPU === "*" ? -1 : a?.cpu?.totalCPU),
                        used_cpu_b: number = Number(b?.cpu?.usedCPU) || 0,
                        total_cpu_b: number = Number(b?.cpu?.totalCPU === "*" ? -1 : b?.cpu?.totalCPU);
                      return used_cpu_a / total_cpu_a - used_cpu_b / total_cpu_b || used_cpu_a - used_cpu_b || total_cpu_a - total_cpu_b;
                    },
                    // sortOrder: default_sorter ? default_sorter.columnKey === "cpuUsage" && default_sorter.order : 'false',
                    render: (cpu: { usedCPU?: string; requestCPU?: string; totalCPU?: string; limitCPU?: string }) => {
                      // const request_cpu: number = Number(cpu?.requestCPU) || 0,
                      const used_cpu: number = Number(cpu?.usedCPU) || 0,
                        total_cpu: number = Number(cpu?.totalCPU === "*" ? -1 : cpu?.totalCPU);
                      return cpu
                        ? {
                          children: (
                            // get_percent(cpu?.usedCPU || '0', cpu?.totalCPU || '*'),
                            <Row align="middle" className={`${path.includes("nodes") ? "min_width_136" : ""}`}>
                              <Col sm={24} className="font-w-7">
                                {show_usage && <span className="font-12">{(Number(used_cpu) || 0).toFixed(2)}/</span>}
                                {(total_cpu && total_cpu !== -1) || total_cpu === 0 ? Number(total_cpu).toFixed(2) : "Unlimited"}
                              </Col>
                              {show_usage && (
                                <Col sm={14}>
                                  <Progress
                                    percent={(Number(used_cpu) / Number(total_cpu)) * 100}
                                    strokeWidth={8}
                                    strokeColor={theme === "dark_blue" ? "#2E7BBF" : theme === "black_gray" ? "#6c748b" : "#4fa1e8"}
                                    showInfo={false}
                                  />
                                </Col>
                              )}
                            </Row>
                          ),
                          props: {
                            "data-title": "Request/Limit of CPU: ",
                          },
                        }
                        : {};
                    },
                  },
                  {
                    title: (
                      <Fragment>
                        <FormattedMessage id="memory" /> ({unit_provide})
                        <br />
                        <span className="font-gray">
                          <FormattedMessage id="request_limit" />
                        </span>
                      </Fragment>
                    ),
                    dataIndex: "memory",
                    key: "memory",
                    className: "text-ellipsis font-w-6",
                    width: `${path.includes("nodes") || path.includes("namespaces") ? "176px" : "160px"}`,
                    // sorter: (a: item, b: item) => {
                    //   const request_memory_a: number = Number(a?.memory?.requestMemory) || 0,
                    //     total_memory_a: number = Number(a?.memory?.totalMemory === "*" ? -1 : a?.memory?.totalMemory),
                    //     limits_memory_a: number = Number(a?.memory?.limitMemory === "*" ? -1 : a?.memory?.limitMemory),
                    //     request_memory_b: number = Number(b?.memory?.requestMemory) || 0,
                    //     total_memory_b: number = Number(b?.memory?.totalMemory === "*" ? -1 : b?.memory?.totalMemory),
                    //     limits_memory_b: number = Number(b?.memory?.limitMemory === "*" ? -1 : b?.memory?.limitMemory);
                    //   return total_memory_a < 0 || limits_memory_a < 0
                    //     ? 1
                    //     : request_memory_a / total_memory_a - request_memory_b / total_memory_b ||
                    //         limits_memory_a / total_memory_a - limits_memory_b / total_memory_b ||
                    //         -1;
                    // },
                    // sortOrder: default_sorter ? default_sorter.columnKey === "memory" && default_sorter.order : 'false',
                    render: (memory: { requestMemory?: string; totalMemory?: string; limitMemory?: string }) => {
                      // const request_memory: number = Number(memory?.requestMemory) || 0,
                      //   total_memory: number = Number(memory?.totalMemory === "*" ? -1 : memory?.totalMemory),
                      //   limits_memory: number = Number(memory?.limitMemory === "*" ? -1 : memory?.limitMemory) || 0;
                      const request_memory = change_unit((memory || {}).requestMemory || "", unit_provide, false),
                        total_memory = change_unit((memory || {}).totalMemory || "", unit_provide, false),
                        limits_memory = change_unit((memory || {}).limitMemory || "", unit_provide, false);
                      return {
                        children: (
                          <Row className={`${path.includes("nodes") ? "min_width_200" : "min_width_144"}`}>
                            <div className="font-w-7 width_65 hidden" style={{ textOverflow: "ellipsis" }} title={request_memory ? request_memory.toFixed(2) : '0.00'}>
                              {request_memory.toFixed(2)}
                            </div>
                            {show_usage && (
                              <Col sm={10} className="ml-5">
                                <Progress
                                  percent={(request_memory / total_memory) * 100}
                                  strokeWidth={8}
                                  strokeColor={theme === "dark_blue" ? "#2E7BBF" : theme === "black_gray" ? "#6c748b" : "#4fa1e8"}
                                  showInfo={false}
                                />
                              </Col>
                            )}
                            <div className="font-w-7 width_65 hidden" style={{ textOverflow: "ellipsis" }} title={limits_memory ? limits_memory.toFixed(2) : '0.00'}>
                              {limits_memory === -1 ? 'Unlimited' : limits_memory.toFixed(2)}
                            </div>
                            {show_usage && (
                              <Col sm={10} className="ml-5">
                                <Progress
                                  percent={(limits_memory / total_memory) * 100}
                                  strokeWidth={8}
                                  strokeColor={theme === "dark_blue" ? "#2E7BBF" : theme === "black_gray" ? "#6c748b" : "#4fa1e8"}
                                  showInfo={false}
                                />
                              </Col>
                            )}
                          </Row>
                        ),
                        props: {
                          "data-title": "Request/Limit of Memory: ",
                        },
                      };
                    },
                  },
                  {
                    title: (
                      <Fragment>
                        <FormattedMessage id="memory" /> ({unit_provide})
                        <br />
                        <span className="font-gray">
                          <FormattedMessage id="usage_quota" />
                        </span>
                      </Fragment>
                    ),
                    dataIndex: "memory",
                    key: "memoryUsage",
                    className: "text-ellipsis font-w-6",
                    sorter: (a: item, b: item) => {
                      const used_memory_a: number = Number(a?.memory?.usedMemory) || 0,
                        total_memory_a: number = Number(a?.memory?.totalMemory === "*" ? -1 : a?.memory?.totalMemory),
                        used_memory_b: number = Number(b?.memory?.usedMemory) || 0,
                        total_memory_b: number = Number(b?.memory?.totalMemory === "*" ? -1 : b?.memory?.totalMemory);
                      return used_memory_a / total_memory_a - used_memory_b / total_memory_b || used_memory_a - used_memory_b || total_memory_a - total_memory_b;
                    },
                    // sortOrder: default_sorter ? default_sorter.columnKey === "memoryUsage" && default_sorter.order : 'false',
                    render: (memory: { usedMemory?: string; totalMemory?: string }) => {
                      const used_memory = change_unit((memory || {}).usedMemory || "", unit_provide, false),
                        total_memory = change_unit((memory || {}).totalMemory || (memory || {}).totalMemory || "", unit_provide, false);
                      return memory
                        ? {
                          children: (
                            <Row
                              align="middle"
                              title={`${used_memory.toFixed(2)}/${(total_memory && total_memory !== -1) || total_memory === 0 ? total_memory.toFixed(2) : "Unlimited"}`}
                            >
                              <Col sm={24} className="font-w-7 text-ellipsis">
                                {show_usage && <span className="font-12">{used_memory.toFixed(2)}/</span>}
                                {(total_memory && total_memory !== -1) || total_memory === 0 ? total_memory.toFixed(2) : "Unlimited"}
                              </Col>
                              {show_usage && (
                                <Col sm={14}>
                                  <Progress
                                    percent={(used_memory / total_memory) * 100}
                                    strokeWidth={8}
                                    strokeColor={theme === "dark_blue" ? "#2E7BBF" : theme === "black_gray" ? "#6c748b" : "#4fa1e8"}
                                    showInfo={false}
                                  />
                                </Col>
                              )}
                            </Row>
                          ),
                          props: {
                            "data-title": "Request/Limit of Memory: ",
                          },
                        }
                        : {};
                    },
                  },
                  {
                    title: `${formatMessage({ id: "rootfs" })} (${unit_provide})`,
                    dataIndex: "rootfs",
                    key: "rootfs",
                    sorter: (a: item, b: item) => {
                      const used_rootfs_a: number = Number(a?.rootfs?.usedRootfs) || 0,
                        total_rootfs_a: number = Number(a?.rootfs?.totalRootfs === "*" ? -1 : a?.rootfs?.totalRootfs),
                        used_rootfs_b: number = Number(b?.rootfs?.usedRootfs) || 0,
                        total_rootfs_b: number = Number(b?.rootfs?.totalRootfs === "*" ? -1 : b?.rootfs?.totalRootfs);
                      return (
                        used_rootfs_a / total_rootfs_a - used_rootfs_b / total_rootfs_b ||
                        used_rootfs_a - used_rootfs_b ||
                        total_rootfs_a - total_rootfs_b
                      );
                    },
                    // sortOrder: default_sorter ? default_sorter.columnKey === "rootfs" && default_sorter.order : 'false',
                    render: (rootfs: { usedRootfs?: string; totalRootfs?: string; limitsRootfs?: string }) => {
                      const used_rootfs = change_unit((rootfs || {}).usedRootfs || "", unit_provide, false),
                        limits_rootfs = change_unit((rootfs || {}).totalRootfs || (rootfs || {}).limitsRootfs || "", unit_provide, false);
                      return rootfs
                        ? {
                          children: (
                            <Row
                              align="middle"
                              className={`${path.includes("nodes") ? "min_width_136" : ""}`}
                              title={`${used_rootfs.toFixed(2)}/${limits_rootfs > -1 ? limits_rootfs.toFixed(2) : "Unlimited"}`}
                            >
                              <Col sm={24} className="font-w-7 text-ellipsis">
                                {show_usage && <span className="font-12">{used_rootfs.toFixed(2)}/</span>}
                                {limits_rootfs > -1 ? limits_rootfs.toFixed(2) : "Unlimited"}
                              </Col>
                              {show_usage && (
                                <Col sm={14}>
                                  <Progress
                                    percent={(used_rootfs / limits_rootfs) * 100}
                                    strokeWidth={8}
                                    strokeColor={theme === "dark_blue" ? "#2E7BBF" : theme === "black_gray" ? "#6c748b" : "#4fa1e8"}
                                    showInfo={false}
                                  />
                                </Col>
                              )}
                            </Row>
                          ),
                          props: {
                            "data-title": `RootFS (${unit_provide}): `,
                          },
                        }
                        : {};
                    },
                  },
                  {
                    title: "GPU",
                    dataIndex: "gpu",
                    width: `${!path.includes("nodes") ? "120px" : ""}`,
                    key: "gpu",
                    sorter: (a: item, b: item) => {
                      const used_gpu_a: number = Number(a?.gpu?.usedGPU) || 0,
                        total_gpu_a: number = Number(a?.gpu?.totalGPU === "*" ? -1 : a?.gpu?.totalGPU),
                        used_gpu_b: number = Number(b?.gpu?.usedGPU) || 0,
                        total_gpu_b: number = Number(b?.gpu?.totalGPU === "*" ? -1 : b?.gpu?.totalGPU);
                      return used_gpu_a / total_gpu_a - used_gpu_b / total_gpu_b || used_gpu_a - used_gpu_b || total_gpu_a - total_gpu_b;
                    },
                    // sortOrder: default_sorter ? default_sorter.columnKey === "gpu" && default_sorter.order : 'false',
                    render: (gpu: { usedGPU?: string; totalGPU?: string; limitsGPU?: string }) => {
                      const used_gpu = Number((gpu || {}).usedGPU || ""),
                        limits_gpu =
                          ((gpu || {}).totalGPU || (gpu || {}).limitsGPU || "") === "*"
                            ? -1
                            : Number((gpu || {}).totalGPU || (gpu || {}).limitsGPU || "");
                      return gpu
                        ? {
                            children: (
                              <Row align="middle" className={`${path.includes("nodes") ? "min_width_136" : ""}`}>
                                <Col sm={24} className="font-w-7">
                                  {show_usage && <span className="font-12">{used_gpu}/</span>}
                                  {limits_gpu > -1 ? limits_gpu : 0}
                                </Col>
                                {show_usage && (
                                  <Col sm={14}>
                                    <Progress
                                      percent={(used_gpu / limits_gpu) * 100}
                                      strokeWidth={8}
                                      strokeColor={theme === "dark_blue" ? "#2E7BBF" : theme === "black_gray" ? "#6c748b" : "#4fa1e8"}
                                      showInfo={false}
                                    />
                                  </Col>
                                )}
                              </Row>
                            ),
                            props: {
                              "data-title": "GPU: ",
                            },
                          }
                        : {};
                    },
                  },
                  {
                    title: "Pod",
                    dataIndex: "pod",
                    width: `${!path.includes("nodes") ? "120px" : ""}`,
                    key: "pod",
                    sorter: (a: item, b: item) => {
                      const used_pod_a: number = Number(a?.pod?.usedPod) || 0,
                        total_pod_a: number = Number(a?.pod?.totalPod === "*" ? -1 : a?.pod?.totalPod),
                        used_pod_b: number = Number(b?.pod?.usedPod) || 0,
                        total_pod_b: number = Number(b?.pod?.totalPod === "*" ? -1 : b?.pod?.totalPod);
                      return used_pod_a / total_pod_a - used_pod_b / total_pod_b || used_pod_a - used_pod_b || total_pod_a - total_pod_b;
                    },
                    // sortOrder: default_sorter ? default_sorter.columnKey === "pod" && default_sorter.order : 'false',
                    render: (pod: { usedPod?: string; totalPod?: string; limitsPod?: string }) => {
                      const used_pod = Number((pod || {}).usedPod || ""),
                        limits_pod =
                          ((pod || {}).totalPod || (pod || {}).limitsPod || "") === "*"
                            ? -1
                            : Number((pod || {}).totalPod || (pod || {}).limitsPod || "");
                      return pod
                        ? {
                          children: (
                            <Row align="middle" className={`${path.includes("nodes") ? "min_width_136" : ""}`}>
                              <Col sm={24} className="font-w-7">
                                {show_usage && <span className="font-12">{used_pod}/</span>}
                                {limits_pod > -1 ? limits_pod : "Unlimited"}
                              </Col>
                              {show_usage && (
                                <Col sm={14}>
                                  <Progress
                                    percent={(used_pod / limits_pod) * 100}
                                    strokeWidth={8}
                                    strokeColor={theme === "dark_blue" ? "#2E7BBF" : theme === "black_gray" ? "#6c748b" : "#4fa1e8"}
                                    showInfo={false}
                                  />
                                </Col>
                              )}
                            </Row>
                          ),
                          props: {
                            "data-title": "Pod: ",
                          },
                        }
                        : {};
                    },
                  },
                  {
                    title: `${formatMessage({ id: "pvc_disk" })} (${unit_provide})`,
                    dataIndex: "pvc",
                    key: "pvc",
                    sorter: (a: item, b: item) => {
                      const used_pvc_a: number = Number(a?.pvc?.usedDisk) || 0,
                        total_pvc_a: number = Number(a?.pvc?.totalDisk === "*" ? -1 : a?.pvc?.totalDisk),
                        used_pvc_b: number = Number(b?.pvc?.usedDisk) || 0,
                        total_pvc_b: number = Number(b?.pvc?.totalDisk === "*" ? -1 : b?.pvc?.totalDisk);
                      return used_pvc_a / total_pvc_a - used_pvc_b / total_pvc_b || used_pvc_a - used_pvc_b || total_pvc_a - total_pvc_b;
                    },
                    // sortOrder: default_sorter ? default_sorter.columnKey === "pvc" && default_sorter.order : 'false',
                    render: (pvc: { usedDisk?: string; totalDisk?: string; limitsDisk?: string }) => {
                      const used_pvc = change_unit((pvc || {}).usedDisk || "", unit_provide, false),
                        limits_disk = change_unit((pvc || {}).totalDisk || (pvc || {}).limitsDisk || "", unit_provide, false);
                      return pvc
                        ? {
                          children: (
                            <Row
                              align="middle"
                              className={`${path.includes("nodes") ? "min_width_136" : ""}`}
                              title={`${used_pvc.toFixed(2)}/${limits_disk > -1 ? limits_disk.toFixed(2) : "Unlimited"}`}
                            >
                              <Col sm={24} className="font-w-7 text-ellipsis">
                                {show_usage && <span className="font-12">{used_pvc.toFixed(2)}/</span>}
                                {limits_disk > -1 ? limits_disk.toFixed(2) : "Unlimited"}
                              </Col>
                              {show_usage && (
                                <Col sm={14}>
                                  <Progress
                                    percent={(used_pvc / limits_disk) * 100}
                                    strokeWidth={8}
                                    strokeColor={theme === "dark_blue" ? "#2E7BBF" : theme === "black_gray" ? "#6c748b" : "#4fa1e8"}
                                    showInfo={false}
                                  />
                                </Col>
                              )}
                            </Row>
                          ),
                          props: {
                            "data-title": `PVC Disk (${unit_provide}): `,
                          },
                        }
                        : {};
                    },
                  },
                ]),
            ]),
        ]),
      ...(path.includes("nodes") || (path.includes("workspaces") && user_info.role === "namespaceDeveloper")
        ? []
        : [
          {
            title: <FormattedMessage id="operation" />,
            width: "97px",
            fixed: `${path.includes("scale") || path.includes("quotas") || path.includes("ingress") || path.includes("restart-alarm") ? "false" : "right"}`,
            dataIndex: "operation",
            key: "operation",
            render: (_text: any, record: row) => {
              return {
                children: (
                  <Col sm={24}>
                    {path.includes("scale") ? (
                      <div
                        onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) => {
                          set_table_list_modal((currentState) => ({
                            ...currentState,
                            action: 4,
                          }));
                          set_item_selected((record as unknown) as item);
                          bind_quota(record.name, event);
                        }}
                      >
                        {record.name === (path.includes("workspace") ? workspace_selected : namespace_selected)?.quotaName ? (
                          <Tooltip title={formatMessage({ id: "unbind" })}>
                            <Button className="plain_button">
                              <img src={linkoff} alt={formatMessage({ id: "unbind" })} />
                            </Button>
                          </Tooltip>
                        ) : (
                            <Tooltip title={formatMessage({ id: "bind" })}>
                              <Button className="plain_button">
                                <img src={linkon} alt={formatMessage({ id: "bind" })} />
                              </Button>
                            </Tooltip>
                          )}
                      </div>
                    ) : (
                        <Dropdown overlay={menu} trigger={["click"]} placement="bottomCenter" disabled={path.includes("quotas") && is_not_workload && !permission[1] ? true : false}>
                          <Button
                            className="plain_button"
                            onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                              prevent(event);
                              const is_cluster: boolean = path.includes("clusters"),
                                is_workspace: boolean = path.includes("workspaces"),
                                is_namespace: boolean = path.includes("namespaces"),
                                is_ingress: boolean = path.includes("ingress");
                              const { name }: item = (record as unknown) as item;
                              if (is_cluster) {
                                set_cluster_selected((record as unknown) as item);
                                name && sessionStorage.setItem("cluster", name);
                              } else if (is_workspace) {
                                set_workspace_selected((record as unknown) as item);
                                set_table_list_modal((currentState) => ({
                                  ...currentState,
                                  quota_selected: record.quotaName,
                                }));
                                name && sessionStorage.setItem("workspace", name);
                              } else if (is_namespace) {
                                set_namespace_selected((record as unknown) as item);
                                name && sessionStorage.setItem("namespace", name);
                              } else if (is_ingress) {
                                set_ingress_selected((record as unknown) as ingress_type_item);
                                name && sessionStorage.setItem("ingress", name);
                              }
                              set_item_selected((record as unknown) as item);
                              if (path.includes("quota")) {
                                const binded_workspaces = workspaces?.filter((workspace) => workspace && workspace.spec?.workspacequota === name),
                                  binded_namespaces =
                                    namespaces &&
                                    namespaces.filter(
                                      (namespace) => namespace && namespace.metadata.labels && namespace.metadata.labels.namespacequota === name
                                    ),
                                  is_workspace = path.indexOf("workspace") > -1,
                                  bind_spaces = is_workspace ? binded_workspaces : binded_namespaces;
                                if (bind_spaces && bind_spaces.length !== 0) {
                                  set_table_list_modal((currentState) => ({
                                    ...currentState,
                                    modal_ok_button: true,
                                  }));
                                } else {
                                  set_quota_is_assigned(false);
                                }
                              }
                            }}
                          >
                            <MoreOutlined />
                          </Button>
                        </Dropdown>
                      )}
                  </Col>
                ),
                props: {
                  "data-title": "Operation: ",
                },
              };
            },
          },
        ]),
    ];
    set_workspace_column(workspace_column_new);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    menu,
    user_info.role,
    path,
    props,
    card_selectable,
    set_workload_selected,
    set_workspace_selected,
    set_namespace_selected,
    set_item_selected,
    workspace_selected,
    namespace_selected,
    set_workspaces,
    unit_provide,
    set_ingress_selected,
    formatMessage,
    default_sorter,
    theme,
    expanded_keys
    // replica_number,
    // show_scale_warning
  ]);

  // 設定預設quota
  useEffect((): void => {
    const default_quotas = path.includes("name")
      ? Array.isArray(quotas) && quotas.filter((quota) => (quota.metadata.labels && quota.metadata.labels.workspace) === workspace_selected?.name)
      : quotas;
    set_table_list_modal((currentState) => ({
      ...currentState,
      quota_selected: `${path === "workspace-info/namespaces" ? "" : (default_quotas || [])[0] && (default_quotas || [])[0].metadata?.name}`,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotas, path, workspace_selected?.name]);

  // 根據頁面設定page_key變數
  useEffect((): void => {
    const name: string = path.substr(path.lastIndexOf("/") + 1);
    set_page_key(key_to_title(name));
  }, [path]);

  useEffect((): void => {
    set_table_desc_el_0(
      <span className="card_title management-label-line font-size-16">
        {table_desc[0]}
      </span>
    );
  }, [table_desc, path]);

  // useEffect((): void => {
  //   set_table_desc_el_1(<div className="card_title_desc no_color small_font mb-5">{table_desc[1]}</div>);
  // }, [table_desc, path]);

  // 渲染頁面上方的統計數字
  useEffect((): void => {
    const has_status: string | object | undefined = items && items[0] && items[0].status,
      is_namespace_scale: boolean = path.includes("namespace/scale"),
      is_scale: boolean = path.includes("workspace/scale") || is_namespace_scale,
      quotaName: string | undefined = (is_namespace_scale ? namespace_selected : workspace_selected)?.quotaName;

    set_summary(
      <div>
        <div className="d-flex flex-end flex-wrap font-14">
          {is_scale && (
            <div className="text-right font-w-6">
              <div className="text-left text-ellipsis">
                <span>
                  <FormattedMessage id="current_cluster" />:
                </span>
                <span className="px-6">
                  {((permissions.clusters as permission_in_roles_array)[user_info.role || ""] || new Int32Array())[3] ? (
                    <Link to="/clusters" title={cluster_selected?.name}>
                      {cluster_selected?.name || "\xa0"}
                    </Link>
                  ) : (
                      cluster_selected?.name || "\xa0"
                    )}
                </span>
              </div>
            </div>
          )}
          {is_scale && (
            <div className="text-right font-w-6 summary-margin">
              <div className="text-left text-ellipsis">
                <span>
                  <FormattedMessage id="current_workspace" />:
                </span>
                <span className="px-6">
                  {((permissions.workspaces as permission_in_roles_array)[user_info.role || ""] || new Int32Array())[3] ? (
                    <Link to="/cluster-info/workspaces" title={workspace_selected?.labels?.name}>
                      {workspace_selected?.labels?.name || "\xa0"}
                    </Link>
                  ) : (
                      workspace_selected?.labels?.name || "\xa0"
                    )}
                </span>
              </div>
            </div>
          )}
          {is_namespace_scale && (
            <div className="text-right font-w-6 summary-margin">
              <div className="text-left text-ellipsis">
                <span>
                  <FormattedMessage id="current_namespace" />:
                </span>
                <Link to="/workspace-info/namespaces" className="px-6" title={namespace_selected?.name}>
                  {namespace_selected?.name || `\xa0`}
                </Link>
              </div>
            </div>
          )}
          <div className="text-right font-w-6 summary-margin">
            <div className="text-left text-ellipsis">
              {path.includes("scale") ? (
                <FormattedMessage id="available_quotas" />
              ) : (
                  <FormattedMessage id={page_key && page_key.toLocaleLowerCase() !== 'restart alarm' ? page_key.toLocaleLowerCase() : "count"} />
                )}
              :
              <span className="px-6">
                {(items || []).length || 0}
              </span>
            </div>
          </div>
          {path.includes("scale") && (
            <div className="text-right font-w-6 summary-margin" title={`Current Quota：${quotaName ? quotaName : "Unlimited"}`}>
              <div className="text-left text-ellipsis">
                <FormattedMessage id="current_quota" />:<span title={quotaName ? quotaName : "Unlimited"} className="px-6">{quotaName ? quotaName : "Unlimited"}</span>
              </div>
            </div>
          )}

          {has_status && table_list_modal.is_logs && (
            <div className="text-right font-w-6 summary-margin">
              <div className="text-left text-ellipsis">
                <FormattedMessage id="active" />:
                <span className="px-6">
                  {items.filter((item: item) => item.status === "Active").length}
                </span>
              </div>
            </div>
          )}
          {has_status && table_list_modal.is_logs && (
            <div className="text-right font-w-6 summary-margin">
              <div className="text-left text-ellipsis">
                <FormattedMessage id="stopped" />:
                <span className="px-6">
                  {items.filter((item: item) => item.status !== "Active").length}
                </span>
              </div>
            </div>
          )}
        </div>
        {/* <Row justify="end" gutter={4}>
          {is_scale && (
            <Col sm={8} xl={6} className="text-right text-white font-w-6">
              <div className="text-left text-ellipsis">
                <span>
                  <FormattedMessage id="current_cluster" />:
                </span>
                <span className="px-6">
                  {((permissions.clusters as permission_in_roles_array)[user_info.role || ""] || new Int32Array())[3] ? (
                    <Link to="/clusters" className="text-white" title={cluster_selected?.name}>
                      {cluster_selected?.name || "\xa0"}
                    </Link>
                  ) : (
                      cluster_selected?.name || "\xa0"
                    )}
                </span>
              </div>
            </Col>
          )}
          {is_scale && (
            <Col sm={8} xl={6} className="text-right text-white font-w-6">
              <div className="text-left text-ellipsis">
                <span>
                  <FormattedMessage id="current_workspace" />:
                </span>
                <span className="px-6">
                  {((permissions.workspaces as permission_in_roles_array)[user_info.role || ""] || new Int32Array())[3] ? (
                    <Link to="/cluster-info/workspaces" className="text-white" title={workspace_selected?.labels?.name}>
                      {workspace_selected?.labels?.name || "\xa0"}
                    </Link>
                  ) : (
                      workspace_selected?.labels?.name || "\xa0"
                    )}
                </span>
              </div>
            </Col>
          )}
          {is_namespace_scale && (
            <Col sm={8} xl={6} className="text-right text-white font-w-6">
              <div className="text-left text-ellipsis">
                <span>
                  <FormattedMessage id="current_namespace" />:
                </span>
                <Link to="/workspace-info/namespaces" className="text-white px-6" title={namespace_selected?.name}>
                  {namespace_selected?.name || `\xa0`}
                </Link>
              </div>
            </Col>
          )}
          <Col sm={8} xl={6} className="text-right text-white font-w-6">
            <div className="text-left text-ellipsis">
              {path.includes("scale") ? (
                <FormattedMessage id="available_quotas" />
              ) : (
                  <FormattedMessage id={page_key ? page_key.toLocaleLowerCase() : "count"} />
                )}
              :
              <span className="px-6">
                {(items || []).length || 0}
              </span>
            </div>
          </Col>
          {path.includes("scale") && (
            <Col sm={8} xl={6} className="text-right text-white font-w-6" title={`Current Quota：${quotaName ? quotaName : "Unlimited"}`}>
              <div className="text-left text-ellipsis">
                <FormattedMessage id="current_quota" />:<span title={quotaName ? quotaName : "Unlimited"} className="px-6">{quotaName ? quotaName : "Unlimited"}</span>
              </div>
            </Col>
          )}

          {has_status && table_list_modal.is_logs && (
            <Col sm={8} md={6} className="text-right text-white font-w-6">
              <div className="text-left text-ellipsis">
                <FormattedMessage id="active" />:
                <span className="px-6">
                  {items.filter((item: item) => item.status === "Active").length}
                </span>
              </div>
            </Col>
          )}
          {has_status && table_list_modal.is_logs && (
            <Col sm={8} md={6} className="text-right text-white font-w-6">
              <div className="text-left text-ellipsis">
                <FormattedMessage id="stopped" />:
                <span className="px-6">
                  {items.filter((item: item) => item.status !== "Active").length}
                </span>
              </div>
            </Col>
          )}
        </Row> */}
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, page_key, path, namespace_selected, workspace_selected, item_selected, cluster_selected, user_info.role, table_list_modal.is_logs]);

  // 渲染麵包屑
  useEffect((): void => {
    if (has_offset) {
      const new_fly_icon: JSX.Element = (
        <Row className="table_breadcrumb_sticky">
          <Col sm={1}>
            {side_fly_in ? (
              <MenuUnfoldOutlined
                className="card_title"
                onClick={() => {
                  set_side_fly_in(!side_fly_in);
                }}
              />
            ) : (
                <MenuFoldOutlined
                  className="card_title"
                  onClick={() => {
                    set_side_fly_in(!side_fly_in);
                  }}
                />
              )}
          </Col>
          {
            <Col sm={22} pull={1} className="px-30">
              <BreadCrumbs />
            </Col>
          }
        </Row>
      );
      set_fly_icon(new_fly_icon);
    }
  }, [has_offset, side_fly_in, set_side_fly_in, path]);

  useEffect(() => {
    if (user_info.role === "workspaceOwner" && cluster_selected?.name && user_info.wkOwner_has_namespacedeveloper.includes(cluster_selected?.name)) {
      const np_no_add = user_info.roles.filter((item: any) => {
        return (
          item.subscriptionId === user_info.subscription_id &&
          item.cluster === cluster_selected?.name &&
          item.workspace === workspace_selected?.name &&
          item.roleName === "namespaceDeveloper"
        );
      });
      set_np_add(np_no_add?.length > 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_info.role, user_info.wkOwner_has_namespacedeveloper, user_info.subscription_id, cluster_selected?.name, workspace_selected?.name, set_np_add]);

  // workloads sacle boolean array
  // useEffect(() => {
  //   const init_array: boolean[] = [];
  //   Array.isArray(items) && items.length > 0 && items.map((item: item)=> {
  //     init_array.push(false);
  //   })
  //   set_show_scale_warning(init_array);
  // },[items, set_show_scale_warning])

  return (
    <TableListModalContext.Provider value={[table_list_modal, set_table_list_modal]}>
      <div className="management-table w-100">
        {fly_icon}
        <TableListModal />
        <div>
          <div>
            <Col sm={24}>{table_desc_el_0}
              <Tooltip placement="rightBottom" title={table_desc[1]}><QuestionCircleOutlined className="autoscale_help" /></Tooltip>
            </Col>
            <div className="management-select-area w-100 position-relative">
              <Row align="middle" justify="space-between"></Row>
              <div className="text-right position-absolute z-index-999" style={{right: '10px', top: `${path.includes("scale") ? "10px" : "6px"}`}}>{summary}</div>
              <Row>
                <DropdownMenu />
                <Col sm={col_width} className="px-6">
                  {path === "clusters" || path.includes("scale") ? "" : <span className="text-white font-w-6 text-center">&nbsp;</span>}
                  <Input
                    className={`${path === "clusters" || path.includes("scale") ? "mt-24" : ""} 'box_rounded' 'input_no_border' 'search_input_height'`}
                    size="large"
                    style={{height: '38px'}}
                    allowClear={true}
                    placeholder={`${formatMessage({
                      id: "please_input_ ",
                    })}${formatMessage({
                      id: path.includes("scale") ? "quota" : path.includes("restart-alarm") ? "pod" : list_type,
                    })}${formatMessage({ id: "name_input" })}`}
                    prefix={<SearchOutlined />}
                    onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                      if (event.keyCode === 13) event.preventDefault();
                    }}
                    onChange={(e) => {
                      set_search_value(e.target.value);
                    }}
                  />
                </Col>
                {(path.includes("clusters") && !user_info.is_globaladmin) ||
                  path.includes("scale") ||
                  path.includes("nodes") ||
                  list_type === "scale" ||
                  list_type === 'storage' ||
                  list_type === 'pv' ||
                  (!path.includes("clusters") && !permission[0]) ||
                  (path.includes("cluster-info/workspaces") && type_name === "shared" && !user_info.is_globaladmin) ||
                  np_add ? (
                    ""
                  ) : (
                    <Col sm={1} className="text-right px-6">
                      {path === "clusters" ? "" : <div className="text-white font-w-6 text-center">&nbsp;</div>}
                      <Button
                        type="primary"
                        className={`${path === "clusters" ? "mt-20" : ""} "plain_button" "create_button"`}
                        style={{ height: "40px" }}
                        onClick={() => {
                          set_table_list_modal((currentState) => ({
                            ...currentState,
                            action: 0,
                            visible: true,
                          }));
                        }}
                      >
                        <PlusOutlined />
                      </Button>
                    </Col>
                  )}
              </Row>
            </div>
          </div>
        </div>
        <Row className="mt-20">
          <Col sm={24} className="big_table_title">
            {table}
          </Col>
        </Row>
      </div>
    </TableListModalContext.Provider>
  );
};

export default injectIntl(withRouter(TableList) as any);
